!(function () {
  "use strict";
  const e = {
      cart: "/cart.js",
      cartAdd: "/cart/add.js",
      cartUpdate: "/cart/update.js",
      cartChange: "/cart/change.js",
      search: "/search/suggest.json",
      productRecommendations: "/recommendations/products.json",
    },
    t = {
      COLORS: {
        primary: { DEFAULT: "#00b67a", dark: "#008f5d", light: "#00d995" },
        secondary: { DEFAULT: "#4791f0", dark: "#3b7dd9", light: "#6ba3f2" },
        background: { DEFAULT: "#1d1e26", light: "#2a2b35", dark: "#15161a" },
        text: { DEFAULT: "#ffffff", muted: "#9ca3af", primary: "#00b67a" },
        success: "#10b981",
        error: "#ef4444",
        warning: "#f59e0b",
        info: "#3b82f6",
      },
      TYPOGRAPHY: {
        fontFamily: {
          sans: ["Inter", "system-ui", "sans-serif"],
          mono: ["JetBrains Mono", "monospace"],
        },
        fontSize: {
          xs: "0.75rem",
          sm: "0.875rem",
          base: "1rem",
          lg: "1.125rem",
          xl: "1.25rem",
          "2xl": "1.5rem",
          "3xl": "1.875rem",
          "4xl": "2.25rem",
          "5xl": "3rem",
        },
        fontWeight: {
          normal: "400",
          medium: "500",
          semibold: "600",
          bold: "700",
        },
      },
      LAYOUT: {
        spacing: { pageWidth: "1200px", sections: "52px", container: "1rem" },
        breakpoints: {
          sm: "640px",
          md: "768px",
          lg: "1024px",
          xl: "1280px",
          "2xl": "1536px",
        },
      },
      PERFORMANCE: {
        lazyLoading: { threshold: 0.1, rootMargin: "0px 0px -50px 0px" },
        debounce: { resize: 250, scroll: 100, input: 300 },
      },
      ACCESSIBILITY: {
        focusRing: { color: "rgba(0, 182, 122, 0.3)", width: "3px" },
        skipLinks: { enabled: !0, target: "#main-content" },
        reducedMotion: { enabled: !0, duration: "0.01ms" },
      },
      CSS_PROPERTIES: {
        primaryColor: "--color-primary",
        secondaryColor: "--color-secondary",
        backgroundColor: "--color-background",
        textColor: "--color-text",
        fontFamily: "--font-family",
        fontSize: "--font-size",
        fontWeight: "--font-weight",
        lineHeight: "--line-height",
        pageWidth: "--page-width",
        sectionSpacing: "--section-spacing",
        containerPadding: "--container-padding",
        animationDuration: "--animation-duration",
        animationEasing: "--animation-easing",
        transitionDuration: "--transition-duration",
        spacing: "--spacing",
        borderRadius: "--border-radius",
        boxShadow: "--box-shadow",
        zIndex: "--z-index",
        fontBodyScale: "--font-body-scale",
        fontHeadingScale: "--font-heading-scale",
      },
      API: {
        endpoints: e,
        defaults: {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
        search: {
          limit: 10,
          resources: "product,collection,page,article",
          section: "predictive-search",
        },
      },
      ON_CHANGE_DEBOUNCE_TIMER: 300,
      PUB_SUB_EVENTS: {
        cartUpdate: "cart-update",
        quantityUpdate: "quantity-update",
        optionValueSelectionChange: "option-value-selection-change",
        variantChange: "variant-change",
        cartError: "cart-error",
        searchUpdate: "search-update",
        modalOpen: "modal-open",
        modalClose: "modal-close",
        drawerOpen: "drawer-open",
        drawerClose: "drawer-close",
        sectionRefresh: "section-refresh",
        themeEditor: "theme-editor",
      },
      SCROLL_FADE_DURATION: 600,
      SCROLL_FADE_THRESHOLD: 0.1,
      BREAKPOINTS: { mobile: 750, tablet: 990, desktop: 1200 },
      Z_INDEX: {
        dropdown: 1e3,
        sticky: 1020,
        fixed: 1030,
        modalBackdrop: 1040,
        modal: 1050,
        popover: 1060,
        tooltip: 1070,
        notification: 1e4,
      },
      API_ENDPOINTS: e,
      THEME_SETTINGS: {
        predictiveSearch: "predictive_search_enabled",
        cartType: "cart_type",
        stickyHeader: "sticky_header_type",
        menuType: "menu_type_desktop",
      },
      CSS_CUSTOM_PROPERTIES: {
        pageWidth: "--page-width",
        colorBackground: "--color-background",
        colorForeground: "--color-foreground",
        colorPrimary: "--color-primary",
        colorSecondary: "--color-secondary",
        fontBodyScale: "--font-body-scale",
        fontHeadingScale: "--font-heading-scale",
        spacingSectionsMobile: "--spacing-sections-mobile",
        spacingSectionsDesktop: "--spacing-sections-desktop",
      },
      getFocusableElements: (e) =>
        Array.from(
          e.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
          )
        ),
      debounce: (e, t) => {
        let s;
        return (...i) => {
          clearTimeout(s), (s = setTimeout(() => e.apply(this, i), t));
        };
      },
      throttle: (e, t) => {
        let s = 0;
        return function (...i) {
          const n = new Date().getTime();
          if (!(n - s < t)) return (s = n), e.apply(this, i);
        };
      },
    };
  "undefined" != typeof module && module.exports
    ? (module.exports = t)
    : ((window.THEME_CONFIG = t), (window.BloxManiaConstants = t));
  let s = {};
  function i(e, t) {
    return (
      void 0 === s[e] && (s[e] = []),
      (s[e] = [...s[e], t]),
      function () {
        s[e] = s[e].filter((e) => e !== t);
      }
    );
  }
  function n(e, t) {
    if (s[e]) {
      const i = s[e]
        .map((s) => {
          try {
            return s(t);
          } catch (t) {
            return (
              console.error(`Error in event subscriber for ${e}:`, t),
              Promise.resolve()
            );
          }
        })
        .filter((e) => e instanceof Promise);
      return Promise.all(i);
    }
    return Promise.resolve();
  }
  (window.subscribe = i),
    (window.publish = n),
    "undefined" != typeof module &&
      module.exports &&
      (module.exports = { subscribe: i, publish: n });
  class o {
    static getFocusableElements(e) {
      return Array.from(
        e.querySelectorAll(
          'summary, a[href], button:enabled, [tabindex]:not([tabindex^="-"]), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe'
        )
      );
    }
    static debounce(e, t) {
      let s;
      return function (...i) {
        clearTimeout(s);
        const n = t || window.THEME_CONFIG?.ON_CHANGE_DEBOUNCE_TIMER || 300;
        s = setTimeout(() => {
          clearTimeout(s), e(...i);
        }, n);
      };
    }
    static throttle(e, t) {
      let s = 0;
      return function (...i) {
        const n = Date.now();
        if (!(n - s < t)) return (s = n), e.apply(this, i);
      };
    }
    static isInViewport(e) {
      const t = e.getBoundingClientRect();
      return (
        t.top >= 0 &&
        t.left >= 0 &&
        t.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        t.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    }
    static smoothScrollTo(e, t = {}) {
      const s = "string" == typeof e ? document.querySelector(e) : e;
      if (!s) return;
      s.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
        ...t,
      });
    }
    static dispatchEvent(e, t = {}, s = document) {
      const i = new CustomEvent(e, { detail: t, bubbles: !0, cancelable: !0 });
      s.dispatchEvent(i);
    }
    static addEventListener(e, t, s, i = {}) {
      return (
        e.addEventListener(t, s, i),
        () => {
          e.removeEventListener(t, s, i);
        }
      );
    }
    static toggleVisibility(e, t, s = "block") {
      t
        ? ((e.style.display = s), e.removeAttribute("hidden"))
        : ((e.style.display = "none"), e.setAttribute("hidden", ""));
    }
    static setLoadingState(e, t) {
      t
        ? (e.setAttribute("aria-busy", "true"), e.classList.add("loading"))
        : (e.removeAttribute("aria-busy"), e.classList.remove("loading"));
    }
    static getComputedStyle(e, t) {
      return window.getComputedStyle(e).getPropertyValue(t);
    }
    static setCSSProperty(e, t, s) {
      e.style.setProperty(t, s);
    }
    static getCSSProperty(e, t) {
      return this.getComputedStyle(e, t);
    }
    static matches(e, t) {
      return e.matches(t);
    }
    static closest(e, t) {
      return e.closest(t);
    }
    static getSiblings(e, t = null) {
      const s = Array.from(e.parentNode.children).filter((t) => t !== e);
      return t ? s.filter((e) => this.matches(e, t)) : s;
    }
    static createElement(e, t = {}, s = null) {
      const i = document.createElement(e);
      return (
        Object.entries(t).forEach(([e, t]) => {
          "className" === e
            ? (i.className = t)
            : "textContent" === e
            ? (i.textContent = t)
            : "innerHTML" === e
            ? (i.innerHTML = t)
            : i.setAttribute(e, t);
        }),
        s &&
          ("string" == typeof s
            ? (i.textContent = s)
            : s instanceof Element && i.appendChild(s)),
        i
      );
    }
    static removeElement(e) {
      e && e.parentNode && e.parentNode.removeChild(e);
    }
    static insertAfter(e, t) {
      t.parentNode.insertBefore(e, t.nextSibling);
    }
    static replaceElement(e, t) {
      e.parentNode.replaceChild(t, e);
    }
  }
  "undefined" != typeof module && module.exports
    ? (module.exports = o)
    : (window.DOMUtils = o);
  class r {
    constructor() {
      (this.cache = new Map()),
        (this.abortControllers = new Map()),
        (this.baseUrl = window.shopUrl || ""),
        (this.config = window.THEME_CONFIG?.API || {});
    }
    async fetchWithErrorHandling(e, t = {}, s = !1) {
      const i = `${e}_${JSON.stringify(t)}`;
      if (s && this.cache.has(i)) return this.cache.get(i);
      this.abortControllers.has(e) && this.abortControllers.get(e).abort();
      const n = new AbortController();
      this.abortControllers.set(e, n);
      const o = {
        method: "GET",
        headers: this.config.defaults?.headers || {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        signal: n.signal,
        ...t,
      };
      try {
        const t = await fetch(e, o);
        if (!t.ok)
          throw (
            (console.warn(`API request failed: ${e} - Status: ${t.status}`),
            new Error(`HTTP error! status: ${t.status}`))
          );
        const n = await t.json();
        return (
          s &&
            200 === t.status &&
            (this.cache.set(i, n), setTimeout(() => this.cache.delete(i), 3e5)),
          n
        );
      } catch (e) {
        if ("AbortError" === e.name) return null;
        throw (console.error("API request failed:", e), e);
      } finally {
        this.abortControllers.delete(e);
      }
    }
    async addToCart(e) {
      const t = `${this.baseUrl}${
          this.config.endpoints?.cartAdd || "/cart/add.js"
        }`,
        s = {
          method: "POST",
          body: e instanceof FormData ? e : JSON.stringify(e),
          headers:
            e instanceof FormData ? {} : { "Content-Type": "application/json" },
        };
      return this.fetchWithErrorHandling(t, s);
    }
    async updateCart(e) {
      const t = `${this.baseUrl}${
          this.config.endpoints?.cartUpdate || "/cart/update.js"
        }`,
        s = {
          method: "POST",
          body: JSON.stringify({ updates: e }),
          headers: { "Content-Type": "application/json" },
        };
      return this.fetchWithErrorHandling(t, s);
    }
    async getCart(e = !0) {
      const t = `${this.baseUrl}${this.config.endpoints?.cart || "/cart.js"}`;
      return this.fetchWithErrorHandling(t, {}, e);
    }
    async changeCartItem(e, t) {
      const s = `${this.baseUrl}${
          this.config.endpoints?.cartChange || "/cart/change.js"
        }`,
        i = {
          method: "POST",
          body: JSON.stringify({ id: e, quantity: t }),
          headers: { "Content-Type": "application/json" },
        };
      return this.fetchWithErrorHandling(s, i);
    }
    async searchProducts(e, t = {}) {
      const {
          limit: s = this.config.search?.limit || 10,
          resources: i = this.config.search?.resources ||
            "product,collection,page,article",
          section: n = this.config.search?.section || "predictive-search",
        } = t,
        o = new URLSearchParams({
          q: e,
          limit: s,
          resources: i,
          section_id: n,
        }),
        r = `${this.baseUrl}/search/suggest.json?${o}`;
      return this.fetchWithErrorHandling(r, {}, !0);
    }
    async getProductRecommendations(e, t = 4) {
      const s = `${this.baseUrl}/recommendations/products.json?product_id=${e}&limit=${t}`;
      return this.fetchWithErrorHandling(s, {}, !0);
    }
    async getCollectionProducts(e, t = {}) {
      const {
          limit: s = 50,
          sort_by: i = "created-descending",
          page: n = 1,
        } = t,
        o = new URLSearchParams({ limit: s, sort_by: i, page: n }),
        r = `${this.baseUrl}/collections/${e}/products.json?${o}`;
      return this.fetchWithErrorHandling(r, {}, !0);
    }
    async submitContactForm(e) {
      const t = `${this.baseUrl}/contact`,
        s = { method: "POST", body: e };
      return this.fetchWithErrorHandling(t, s);
    }
    async subscribeNewsletter(e, t = {}) {
      const s = new FormData();
      s.append("contact[email]", e),
        s.append("contact[tags]", "newsletter"),
        Object.entries(t).forEach(([e, t]) => {
          s.append(e, t);
        });
      const i = `${this.baseUrl}/contact`,
        n = { method: "POST", body: s };
      return this.fetchWithErrorHandling(i, n);
    }
    clearCache() {
      this.cache.clear();
    }
    abortAllRequests() {
      this.abortControllers.forEach((e) => e.abort()),
        this.abortControllers.clear();
    }
    getCacheStats() {
      return {
        size: this.cache.size,
        keys: Array.from(this.cache.keys()),
        pendingRequests: this.abortControllers.size,
      };
    }
  }
  (window.APIUtils = new r()),
    "undefined" != typeof module && module.exports && (module.exports = r);
  class a {
    constructor() {
      (this.isReducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      ).matches),
        this.init();
    }
    init() {
      this.isReducedMotion || this.setupScrollFade();
    }
    setupScrollFade() {
      const e = document.querySelectorAll("section, .section-fade-in");
      if (0 === e.length) return;
      const t = new IntersectionObserver(
        (e) => {
          e.forEach((e) => {
            e.isIntersecting &&
              (e.target.classList.add("fade-in-visible"),
              t.unobserve(e.target));
          });
        },
        { threshold: 0.01, rootMargin: "0px 0px -200px 0px" }
      );
      e.forEach((e) => {
        t.observe(e);
      });
    }
  }
  class c {
    constructor() {
      this.init();
    }
    init() {
      this.initHoverEffects(), this.initFocusEffects(), this.initClickEffects();
    }
    initHoverEffects() {
      document.querySelectorAll("[data-hover]").forEach((e) => {
        const t = e.dataset.hover;
        e.classList.add(`hover-${t}`);
      });
    }
    initFocusEffects() {
      document
        .querySelectorAll("button, a, input, select, textarea")
        .forEach((e) => {
          e.classList.add("focus-ring");
        });
    }
    initClickEffects() {
      document.querySelectorAll("button").forEach((e) => {
        e.addEventListener("click", (e) => {
          this.createRippleEffect(e);
        });
      });
    }
    createRippleEffect(e) {
      const t = e.currentTarget,
        s = document.createElement("span"),
        i = t.getBoundingClientRect(),
        n = Math.max(i.width, i.height),
        o = e.clientX - i.left - n / 2,
        r = e.clientY - i.top - n / 2;
      (s.style.cssText = `\n      position: absolute;\n      width: ${n}px;\n      height: ${n}px;\n      left: ${o}px;\n      top: ${r}px;\n      background: rgba(255, 255, 255, 0.3);\n      border-radius: 50%;\n      transform: scale(0);\n      animation: ripple 0.6s linear;\n      pointer-events: none;\n    `),
        t.appendChild(s),
        setTimeout(() => {
          s.remove();
        }, 600);
    }
  }
  class l {
    constructor() {
      this.init();
    }
    init() {
      this.initLazyLoading(),
        this.initSmoothScrolling(),
        this.initDebouncedResize();
    }
    initLazyLoading() {
      const e = new IntersectionObserver((t) => {
        t.forEach((t) => {
          if (t.isIntersecting) {
            const s = t.target;
            s.dataset.src &&
              ((s.src = s.dataset.src),
              s.removeAttribute("data-src"),
              s.classList.remove("lazy")),
              e.unobserve(s);
          }
        });
      });
      document.querySelectorAll("img[data-src]").forEach((t) => {
        e.observe(t);
      });
    }
    initSmoothScrolling() {
      document.querySelectorAll('a[href^="#"]').forEach((e) => {
        e.addEventListener("click", (t) => {
          t.preventDefault();
          const s = document.querySelector(e.getAttribute("href"));
          s && s.scrollIntoView({ behavior: "smooth", block: "start" });
        });
      });
    }
    initDebouncedResize() {
      let e;
      window.addEventListener("resize", () => {
        clearTimeout(e);
        const t = window.THEME_CONFIG?.PERFORMANCE?.debounce?.resize || 250;
        e = setTimeout(() => {
          this.handleResize();
        }, t);
      });
    }
    handleResize() {
      const e = window.innerWidth <= 768;
      document.body.classList.toggle("mobile", e);
    }
  }
  class d {
    constructor() {
      this.init();
    }
    init() {
      this.initSkipLinks(),
        this.initFocusManagement(),
        this.initKeyboardNavigation();
    }
    initSkipLinks() {
      [
        { href: "#main-content", text: "Skip to main content" },
        { href: "#navigation", text: "Skip to navigation" },
      ].forEach((e) => {
        const t = document.createElement("a");
        (t.href = e.href),
          (t.textContent = e.text),
          (t.className = "skip-link"),
          (t.style.cssText =
            "\n        position: absolute;\n        top: -40px;\n        left: 6px;\n        background: #000;\n        color: #fff;\n        padding: 8px;\n        text-decoration: none;\n        z-index: 1000;\n        transition: top 0.3s;\n      "),
          t.addEventListener("focus", () => {
            t.style.top = "6px";
          }),
          t.addEventListener("blur", () => {
            t.style.top = "-40px";
          }),
          document.body.appendChild(t);
      });
    }
    initFocusManagement() {
      document.addEventListener("keydown", (e) => {
        if ("Escape" === e.key) {
          document.querySelectorAll("[data-modal].active").forEach((e) => {
            e.classList.remove("active");
          });
        }
      });
    }
    initKeyboardNavigation() {
      document.addEventListener("keydown", (e) => {
        if (e.ctrlKey || e.metaKey)
          switch (e.key) {
            case "k":
              e.preventDefault();
              const t = document.querySelector("[data-search-input]");
              t && t.focus();
              break;
            case "/":
              e.preventDefault();
          }
      });
    }
  }
  const u = new (class {
    constructor() {
      (this.animationController = null),
        (this.interactionController = null),
        (this.performanceController = null),
        (this.accessibilityController = null),
        (this.creatorsCarousel = null),
        this.init();
    }
    init() {
      this.setup();
    }
    setup() {
      (this.animationController = new a()),
        (this.interactionController = new c()),
        (this.performanceController = new l()),
        (this.accessibilityController = new d()),
        this.initThemeFeatures();
    }
    initThemeFeatures() {
      this.initViewToggles(), this.initSearch(), this.initCart();
    }
    initViewToggles() {
      document.querySelectorAll("[data-view-toggle]").forEach((e) => {
        e.addEventListener("click", (t) => {
          t.preventDefault();
          const s = e.dataset.view;
          this.setView(s);
        });
      });
    }
    setView(e) {
      localStorage.setItem("product-view", e),
        document.querySelectorAll("[data-view]").forEach((t) => {
          t.dataset.view = e;
        });
    }
    initSearch() {
      document.querySelectorAll("[data-search-form]").forEach((e) => {
        e.addEventListener("submit", (e) => {});
      });
    }
    initCart() {
      document.querySelectorAll("[data-cart-add]").forEach((e) => {
        e.addEventListener("click", (t) => {
          t.preventDefault();
          const s = e.dataset.productId;
          this.addToCart(s);
        });
      });
    }
    addToCart(e) {}
  })();
  async function h() {
    try {
      await new Promise((e) => {
        const t = () => {
          window.BloxManiaConstants &&
          window.SectionId &&
          window.HTMLUpdateUtility
            ? e()
            : setTimeout(t, 10);
        };
        t();
      }),
        document.documentElement.classList.add("theme-loaded"),
        document.dispatchEvent(
          new CustomEvent("theme:loaded", {
            detail: {
              constants: window.BloxManiaConstants,
              utilities: {
                SectionId: window.SectionId,
                HTMLUpdateUtility: window.HTMLUpdateUtility,
                DOMUtils: window.DOMUtils,
                subscribe: window.subscribe,
                publish: window.publish,
              },
              components: window.BloxManiaComponents,
            },
          })
        ),
        console.log("BloxMania theme initialized successfully");
    } catch (e) {
      console.error("Theme initialization failed:", e);
    }
  }
  if (
    ((window.BloxManiaCore = {
      animation: u.animationController,
      interaction: u.interactionController,
      performance: u.performanceController,
      accessibility: u.accessibilityController,
      formatPrice: function (e, t = "USD") {
        return new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: t,
        }).format(e);
      },
      showNotification: function (e, t = "success") {
        const s = document.createElement("div");
        (s.className = `notification notification-${t}`),
          (s.textContent = e),
          (s.style.cssText =
            "\n    position: fixed;\n    top: 20px;\n    right: 20px;\n    padding: 12px 20px;\n    border-radius: 8px;\n    color: white;\n    z-index: 1000;\n    transform: translateX(100%);\n    transition: transform 0.3s ease;\n  ");
        const i = {
          success: "#10b981",
          error: "#ef4444",
          warning: "#f59e0b",
          info: "#3b82f6",
        };
        (s.style.backgroundColor = i[t] || i.info),
          document.body.appendChild(s),
          requestAnimationFrame(() => {
            s.style.transform = "translateX(0)";
          }),
          setTimeout(() => {
            (s.style.transform = "translateX(100%)"),
              setTimeout(() => {
                document.body.removeChild(s);
              }, 300);
          }, 3e3);
      },
    }),
    "loading" === document.readyState
      ? document.addEventListener("DOMContentLoaded", h)
      : h(),
    document.addEventListener("DOMContentLoaded", function () {
      document.fonts &&
        document.fonts.ready &&
        document.fonts.ready.then(() => {
          console.log("✅ Fonts loaded successfully");
        }),
        document
          .querySelectorAll('link[rel="preload"][as="font"]')
          .forEach((e) => {
            e.hasAttribute("crossorigin") ||
              e.setAttribute("crossorigin", "anonymous"),
              e.setAttribute("media", "print"),
              e.setAttribute("onload", "this.media='all'");
          }),
        "fonts" in document && console.log("✅ Fonts loaded successfully");
    }),
    window.Shopify?.designMode &&
      document.addEventListener("shopify:section:load", () => {
        setTimeout(h, 100);
      }),
    (window.BloxManiaInit = { initializeTheme: h }),
    "undefined" == typeof SectionId)
  ) {
    class e {
      constructor(e) {
        this.value = e;
      }
      static getIdForSection(t) {
        if (!t) return null;
        const s =
          t.dataset.sectionId ||
          t.id ||
          t.closest("[data-section-id]")?.dataset.sectionId ||
          t.closest("[id]")?.id;
        return s ? new e(s) : null;
      }
      static parseId(t) {
        if (!t) return null;
        const s = [
          /[?&]section_id=([^&]+)/,
          /[?&]sections=([^&]+)/,
          /#([^&?]+)/,
          /sections\/([^\/]+)/,
        ];
        for (const i of s) {
          const s = t.match(i);
          if (s) return new e(s[1]);
        }
        return null;
      }
      getSection() {
        return (
          document.getElementById(this.value) ||
          document.querySelector(`[data-section-id="${this.value}"]`)
        );
      }
      getSettings() {
        const e = this.getSection();
        return e ? e.querySelector('script[type="application/json"]') : null;
      }
      parseSettings() {
        const e = this.getSettings();
        if (!e) return null;
        try {
          return JSON.parse(e.textContent);
        } catch (e) {
          return console.error("Error parsing section settings:", e), null;
        }
      }
      updateSettings(e) {
        const t = this.getSettings();
        t && (t.textContent = JSON.stringify(e));
      }
      getBlocks() {
        const e = this.getSection();
        return e ? e.querySelectorAll("[data-block-id]") : [];
      }
      getBlock(e) {
        const t = this.getSection();
        return t ? t.querySelector(`[data-block-id="${e}"]`) : null;
      }
      generateUrl(e = {}) {
        const t = new URL(window.location.href);
        return (
          t.searchParams.set("section_id", this.value),
          Object.entries(e).forEach(([e, s]) => {
            t.searchParams.set(e, s);
          }),
          t.toString()
        );
      }
      exists() {
        return !!this.getSection();
      }
      getType() {
        const e = this.getSection();
        return (
          (e &&
            (e.dataset.sectionType ||
              e.className.match(/section--(\w+)/)?.[1])) ||
          null
        );
      }
      isVisible() {
        const e = this.getSection();
        if (!e) return !1;
        const t = e.getBoundingClientRect();
        return t.top < window.innerHeight && t.bottom > 0;
      }
      toString() {
        return this.value;
      }
    }
    (e.getAllSections = function () {
      const t = document.querySelectorAll(
        '[data-section-id], [id^="shopify-section-"]'
      );
      return Array.from(t).map((t) => {
        const s = t.dataset.sectionId || t.id;
        return new e(s);
      });
    }),
      (e.getCurrentSection = function () {
        const t = window.location.hash.slice(1);
        return t ? new e(t) : null;
      }),
      (window.SectionId = e),
      "undefined" != typeof module && module.exports && (module.exports = e);
  }
  if ("undefined" == typeof HTMLUpdateUtility) {
    class e {
      static updateHTML(e, t, s = {}) {
        const {
            executeScripts: i = !0,
            preserveScroll: n = !1,
            focusElement: o = null,
            onComplete: r = null,
          } = s,
          a = n ? { x: window.scrollX, y: window.scrollY } : null,
          c = document.createElement("div");
        c.innerHTML = t;
        const l = c.querySelectorAll("script"),
          d = [];
        i &&
          l.forEach((e) => {
            const t = document.createElement("script");
            if (
              (Array.from(e.attributes).forEach((e) => {
                t.setAttribute(e.name, e.value);
              }),
              e.src || (t.textContent = e.textContent),
              e.src)
            ) {
              const e = new Promise((e, s) => {
                (t.onload = e), (t.onerror = s);
              });
              d.push(e);
            }
            e.parentNode.replaceChild(t, e);
          }),
          (e.innerHTML = c.innerHTML),
          Promise.all(d)
            .then(() => {
              if ((a && window.scrollTo(a.x, a.y), o)) {
                const t = "string" == typeof o ? e.querySelector(o) : o;
                t && t.focus();
              }
              r && r(e),
                e.dispatchEvent(
                  new CustomEvent("html:updated", {
                    detail: { targetElement: e, newHTML: t },
                  })
                );
            })
            .catch((e) => {
              console.error("Error loading scripts during HTML update:", e);
            });
      }
      static updateSections(e, t = {}) {
        Object.entries(e).forEach(([e, s]) => {
          const i = document.getElementById(e);
          i && this.updateHTML(i, s, t);
        });
      }
      static parseHTML(e) {
        const t = new DOMParser().parseFromString(e, "text/html"),
          s = document.createDocumentFragment();
        for (; t.body.firstChild; ) s.appendChild(t.body.firstChild);
        return s;
      }
      static extractElement(e, t) {
        const s = document.createElement("div");
        return (s.innerHTML = e), s.querySelector(t);
      }
      static mergeAttributes(e, t, s = ["id", "class"]) {
        Array.from(t.attributes).forEach((t) => {
          s.includes(t.name) || e.setAttribute(t.name, t.value);
        });
      }
    }
    (window.HTMLUpdateUtility = e),
      "undefined" != typeof module && module.exports && (module.exports = e);
  }
  class m {
    constructor() {
      this.init();
    }
    init() {
      this.setupSkipLinks(),
        this.setupFocusRing(),
        this.setupKeyboardNavigation(),
        this.setupScreenReaderAnnouncements(),
        this.enhanceExistingElements();
    }
    setupSkipLinks() {}
    setupFocusRing() {
      document.addEventListener("keydown", (e) => {
        "Tab" === e.key && document.body.classList.add("keyboard-focus");
      }),
        document.addEventListener("mousedown", () => {
          document.body.classList.remove("keyboard-focus");
        });
    }
    setupKeyboardNavigation() {
      document
        .querySelectorAll('.dropdown, [aria-haspopup="true"]')
        .forEach((e) => {
          if (e.hasAttribute("data-keyboard-nav")) return;
          e.setAttribute("data-keyboard-nav", "true");
          const t = e.querySelector("button, [aria-expanded]"),
            s = e.querySelector('[role="menu"], .dropdown-menu');
          if (!t || !s) return;
          t.hasAttribute("aria-expanded") ||
            t.setAttribute("aria-expanded", "false"),
            t.hasAttribute("aria-haspopup") ||
              t.setAttribute("aria-haspopup", "true"),
            s.hasAttribute("role") || s.setAttribute("role", "menu");
          const i = s.querySelectorAll('a, button, [role="menuitem"]');
          i.forEach((e) => {
            e.hasAttribute("role") || e.setAttribute("role", "menuitem"),
              e.hasAttribute("tabindex") || e.setAttribute("tabindex", "-1");
          }),
            t.addEventListener("keydown", (e) => {
              ("ArrowDown" !== e.key && "Enter" !== e.key && " " !== e.key) ||
                (e.preventDefault(),
                t.setAttribute("aria-expanded", "true"),
                i[0]?.focus());
            }),
            s.addEventListener("keydown", (e) => {
              const s = Array.from(i).indexOf(document.activeElement);
              switch (e.key) {
                case "ArrowDown":
                  e.preventDefault(),
                    s < i.length - 1 ? i[s + 1].focus() : i[0].focus();
                  break;
                case "ArrowUp":
                  e.preventDefault(),
                    s > 0 ? i[s - 1].focus() : i[i.length - 1].focus();
                  break;
                case "Escape":
                  e.preventDefault(),
                    t.setAttribute("aria-expanded", "false"),
                    t.focus();
                  break;
                case "Tab":
                  e.shiftKey || s !== i.length - 1
                    ? e.shiftKey &&
                      0 === s &&
                      t.setAttribute("aria-expanded", "false")
                    : t.setAttribute("aria-expanded", "false");
              }
            }),
            document.addEventListener("click", (s) => {
              e.contains(s.target) || t.setAttribute("aria-expanded", "false");
            });
        }),
        document.querySelectorAll('[role="tablist"]').forEach((e) => {
          if (e.hasAttribute("data-keyboard-nav")) return;
          e.setAttribute("data-keyboard-nav", "true");
          const t = e.querySelectorAll('[role="tab"]');
          e.addEventListener("keydown", (e) => {
            const s = Array.from(t).indexOf(document.activeElement);
            if (-1 !== s)
              switch (e.key) {
                case "ArrowRight":
                  e.preventDefault(),
                    s < t.length - 1
                      ? (t[s + 1].focus(), t[s + 1].click())
                      : (t[0].focus(), t[0].click());
                  break;
                case "ArrowLeft":
                  e.preventDefault(),
                    s > 0
                      ? (t[s - 1].focus(), t[s - 1].click())
                      : (t[t.length - 1].focus(), t[t.length - 1].click());
                  break;
                case "Home":
                  e.preventDefault(), t[0].focus(), t[0].click();
                  break;
                case "End":
                  e.preventDefault(),
                    t[t.length - 1].focus(),
                    t[t.length - 1].click();
              }
          });
        });
    }
    setupScreenReaderAnnouncements() {
      if (!document.getElementById("sr-announcements")) {
        const e = document.createElement("div");
        (e.id = "sr-announcements"),
          (e.className = "sr-only"),
          e.setAttribute("aria-live", "polite"),
          e.setAttribute("aria-atomic", "true"),
          document.body.appendChild(e);
      }
    }
    enhanceExistingElements() {
      document.querySelectorAll("img:not([alt])").forEach((e) => {
        e.alt = "";
      }),
        document.querySelectorAll("header:not([role])").forEach((e) => {
          e.setAttribute("role", "banner");
        }),
        document.querySelectorAll("footer:not([role])").forEach((e) => {
          e.setAttribute("role", "contentinfo");
        }),
        document.querySelectorAll("nav:not([role])").forEach((e) => {
          e.setAttribute("role", "navigation"),
            e.hasAttribute("aria-label") ||
              e.setAttribute("aria-label", "Main");
        }),
        document.querySelectorAll("main:not([role])").forEach((e) => {
          e.setAttribute("role", "main");
        }),
        document.querySelectorAll("button:not([type])").forEach((e) => {
          e.setAttribute("type", "button");
        }),
        document
          .querySelectorAll("input:not([aria-label]):not([aria-labelledby])")
          .forEach((e) => {
            const t = e.id;
            if (t) {
              if (!document.querySelector(`label[for="${t}"]`)) {
                const s = document.createElement("label");
                (s.htmlFor = t),
                  (s.className = "sr-only"),
                  (s.textContent = e.placeholder || e.name || "Input field"),
                  e.parentNode.insertBefore(s, e);
              }
            } else e.placeholder && e.setAttribute("aria-label", e.placeholder);
          });
    }
    getFocusableElements(e = document) {
      return o.getFocusableElements(e);
    }
    trapFocus(e) {
      const t = this.getFocusableElements(e);
      if (0 === t.length) return () => {};
      const s = t[0],
        i = t[t.length - 1];
      s.focus();
      const n = (e) => {
        "Tab" === e.key &&
          (e.shiftKey
            ? document.activeElement === s && (e.preventDefault(), i.focus())
            : document.activeElement === i && (e.preventDefault(), s.focus()));
      };
      return (
        e.addEventListener("keydown", n),
        () => {
          e.removeEventListener("keydown", n);
        }
      );
    }
    announce(e, t = "polite") {
      const s = document.getElementById("sr-announcements");
      s &&
        ((s.textContent = ""),
        s.setAttribute("aria-live", t),
        setTimeout(() => {
          s.textContent = e;
        }, 100),
        setTimeout(() => {
          s.textContent = "";
        }, 5e3));
    }
    createScreenReaderText(e, t = "span") {
      const s = document.createElement(t);
      return (s.className = "sr-only"), (s.textContent = e), s;
    }
    addLoadingAnnouncement(e, t = "Loading...", s = "Content loaded") {
      e.setAttribute("aria-busy", "true"), this.announce(t);
      const i = new MutationObserver(() => {
        (e.hasAttribute("aria-busy") &&
          "false" !== e.getAttribute("aria-busy")) ||
          (this.announce(s), i.disconnect());
      });
      i.observe(e, { attributes: !0, attributeFilter: ["aria-busy"] });
    }
    enhanceFormAccessibility(e) {
      e.querySelectorAll("input, select, textarea").forEach((e) => {
        e.hasAttribute("required") &&
          !e.hasAttribute("aria-required") &&
          e.setAttribute("aria-required", "true"),
          e.addEventListener("invalid", (t) => {
            const s = `${e.id || e.name}-error`;
            let i = document.getElementById(s);
            i ||
              ((i = document.createElement("div")),
              (i.id = s),
              (i.className = "error-message"),
              i.setAttribute("role", "alert"),
              e.parentNode.insertBefore(i, e.nextSibling)),
              (i.textContent = e.validationMessage),
              e.setAttribute("aria-describedby", s),
              e.setAttribute("aria-invalid", "true");
          }),
          e.addEventListener("input", () => {
            if (e.validity.valid) {
              e.removeAttribute("aria-invalid");
              const t = `${e.id || e.name}-error`,
                s = document.getElementById(t);
              s && (s.textContent = "");
            }
          });
      });
    }
    checkColorContrast(e) {
      const t = window.getComputedStyle(e);
      return {
        backgroundColor: t.backgroundColor,
        color: t.color,
        warning: "Use a proper contrast checking tool for accurate results",
      };
    }
  }
  "loading" === document.readyState
    ? document.addEventListener("DOMContentLoaded", () => {
        window.accessibilityUtils = new m();
      })
    : (window.accessibilityUtils = new m()),
    "undefined" != typeof module && module.exports && (module.exports = m);
  class p {
    constructor() {
      (this.shortcuts = new Map()),
        (this.focusHistory = []),
        (this.currentFocusIndex = -1),
        (this.isKeyboardUser = !1),
        this.init();
    }
    init() {
      this.setupKeyboardDetection(),
        this.setupGlobalKeyboardShortcuts(),
        this.setupFocusManagement(),
        this.setupCustomElements(),
        this.setupModalNavigation(),
        this.setupTableNavigation(),
        this.setupCarouselNavigation();
    }
    setupKeyboardDetection() {
      document.addEventListener("keydown", (e) => {
        "Tab" === e.key &&
          ((this.isKeyboardUser = !0),
          document.body.classList.add("keyboard-user"));
      }),
        document.addEventListener("mousedown", () => {
          (this.isKeyboardUser = !1),
            document.body.classList.remove("keyboard-user");
        }),
        document.addEventListener("touchstart", () => {
          (this.isKeyboardUser = !1),
            document.body.classList.remove("keyboard-user");
        });
    }
    setupGlobalKeyboardShortcuts() {}
    setupFocusManagement() {
      document.addEventListener("focusin", (e) => {
        this.isKeyboardUser && this.addToFocusHistory(e.target);
      }),
        document.addEventListener("keydown", (e) => {
          e.altKey && "ArrowLeft" === e.key
            ? (e.preventDefault(), this.focusPrevious())
            : e.altKey &&
              "ArrowRight" === e.key &&
              (e.preventDefault(), this.focusNext());
        }),
        document.addEventListener("focusin", (e) => {
          this.isKeyboardUser && this.ensureFocusVisible(e.target);
        });
    }
    setupCustomElements() {
      this.setupProductCardNavigation(),
        this.setupFormNavigation(),
        this.setupButtonGroupNavigation();
    }
    setupProductCardNavigation() {
      document.querySelectorAll(".product-card, .card-product").forEach((e) => {
        e.hasAttribute("data-keyboard-nav") ||
          (e.setAttribute("data-keyboard-nav", "true"),
          e.hasAttribute("tabindex") || e.setAttribute("tabindex", "0"),
          e.hasAttribute("role") || e.setAttribute("role", "article"),
          e.addEventListener("keydown", (t) => {
            switch (t.key) {
              case "Enter":
              case " ":
                t.preventDefault();
                const s = e.querySelector("a");
                s && s.click();
                break;
              case "ArrowRight":
              case "ArrowDown":
                t.preventDefault(), this.focusNextCard(e);
                break;
              case "ArrowLeft":
              case "ArrowUp":
                t.preventDefault(), this.focusPreviousCard(e);
            }
          }));
      });
    }
    setupFormNavigation() {
      document.querySelectorAll("form").forEach((e) => {
        e.hasAttribute("data-keyboard-nav") ||
          (e.setAttribute("data-keyboard-nav", "true"),
          e.addEventListener("keydown", (t) => {
            t.ctrlKey && "Enter" === t.key && (t.preventDefault(), e.submit());
          }));
      });
    }
    setupButtonGroupNavigation() {
      document.querySelectorAll(".button-group, .btn-group").forEach((e) => {
        if (e.hasAttribute("data-keyboard-nav")) return;
        e.setAttribute("data-keyboard-nav", "true");
        const t = e.querySelectorAll('button, [role="button"]');
        t.forEach((e, t) => {
          e.setAttribute("tabindex", 0 === t ? "0" : "-1");
        }),
          e.addEventListener("keydown", (e) => {
            const s = Array.from(t).indexOf(e.target);
            if (-1 === s) return;
            let i = s;
            switch (e.key) {
              case "ArrowRight":
              case "ArrowDown":
                e.preventDefault(), (i = (s + 1) % t.length);
                break;
              case "ArrowLeft":
              case "ArrowUp":
                e.preventDefault(), (i = (s - 1 + t.length) % t.length);
                break;
              case "Home":
                e.preventDefault(), (i = 0);
                break;
              case "End":
                e.preventDefault(), (i = t.length - 1);
                break;
              default:
                return;
            }
            t[s].setAttribute("tabindex", "-1"),
              t[i].setAttribute("tabindex", "0"),
              t[i].focus();
          });
      });
    }
    setupModalNavigation() {
      document.addEventListener("keydown", (e) => {
        const t = document.querySelector(
          '.modal.active, [role="dialog"][aria-hidden="false"]'
        );
        t && "Tab" === e.key && this.trapFocusInModal(e, t);
      });
    }
    setupTableNavigation() {
      document.querySelectorAll("table").forEach((e) => {
        e.hasAttribute("data-keyboard-nav") ||
          (e.setAttribute("data-keyboard-nav", "true"),
          e.hasAttribute("tabindex") || e.setAttribute("tabindex", "0"),
          e.addEventListener("keydown", (t) => {
            if (!this.isKeyboardUser) return;
            const s = e.querySelectorAll("td, th"),
              i = t.target.closest("td, th");
            if (!i) return;
            const n = Array.from(s).indexOf(i),
              o = e.rows[0]?.cells.length || 0;
            e.rows.length;
            let r = n;
            switch (t.key) {
              case "ArrowRight":
                t.preventDefault(), (r = Math.min(n + 1, s.length - 1));
                break;
              case "ArrowLeft":
                t.preventDefault(), (r = Math.max(n - 1, 0));
                break;
              case "ArrowDown":
                t.preventDefault(), (r = Math.min(n + o, s.length - 1));
                break;
              case "ArrowUp":
                t.preventDefault(), (r = Math.max(n - o, 0));
                break;
              case "Home":
                t.preventDefault(), (r = Math.floor(n / o) * o);
                break;
              case "End":
                t.preventDefault(),
                  (r = Math.min((Math.floor(n / o) + 1) * o - 1, s.length - 1));
                break;
              default:
                return;
            }
            s[r] && s[r].focus();
          }),
          e.querySelectorAll("td, th").forEach((e) => {
            e.hasAttribute("tabindex") || e.setAttribute("tabindex", "-1");
          }));
      });
    }
    setupCarouselNavigation() {
      document.querySelectorAll(".carousel, .slider").forEach((e) => {
        e.hasAttribute("data-keyboard-nav") ||
          (e.setAttribute("data-keyboard-nav", "true"),
          e.addEventListener("keydown", (t) => {
            switch (t.key) {
              case "ArrowLeft":
                t.preventDefault(), this.carouselPrevious(e);
                break;
              case "ArrowRight":
                t.preventDefault(), this.carouselNext(e);
                break;
              case "Home":
                t.preventDefault(), this.carouselGoTo(e, 0);
                break;
              case "End":
                t.preventDefault();
                const s = e.querySelectorAll(".slide, .carousel-item");
                this.carouselGoTo(e, s.length - 1);
            }
          }));
      });
    }
    registerShortcut(e, t, s) {
      this.shortcuts.set(e, { handler: t, description: s });
    }
    isTypingContext(e) {
      const t = e.isContentEditable;
      return ["INPUT", "TEXTAREA", "SELECT"].includes(e.tagName) || t;
    }
    addToFocusHistory(e) {
      const t = this.focusHistory.indexOf(e);
      -1 !== t && this.focusHistory.splice(t, 1),
        this.focusHistory.push(e),
        (this.currentFocusIndex = this.focusHistory.length - 1),
        this.focusHistory.length > 50 &&
          (this.focusHistory.shift(), this.currentFocusIndex--);
    }
    focusPrevious() {
      if (this.currentFocusIndex > 0) {
        this.currentFocusIndex--;
        const e = this.focusHistory[this.currentFocusIndex];
        e && document.contains(e) && e.focus();
      }
    }
    focusNext() {
      if (this.currentFocusIndex < this.focusHistory.length - 1) {
        this.currentFocusIndex++;
        const e = this.focusHistory[this.currentFocusIndex];
        e && document.contains(e) && e.focus();
      }
    }
    ensureFocusVisible(e) {
      e.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "nearest",
      }),
        e.classList.add("keyboard-focused"),
        setTimeout(() => {
          e.classList.remove("keyboard-focused");
        }, 2e3);
    }
    focusNextCard(e) {
      const t = document.querySelectorAll(".product-card, .card-product"),
        s = (Array.from(t).indexOf(e) + 1) % t.length;
      t[s] && t[s].focus();
    }
    focusPreviousCard(e) {
      const t = document.querySelectorAll(".product-card, .card-product"),
        s = (Array.from(t).indexOf(e) - 1 + t.length) % t.length;
      t[s] && t[s].focus();
    }
    trapFocusInModal(e, t) {
      const s = t.querySelectorAll(
          'a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select, [tabindex]:not([tabindex="-1"])'
        ),
        i = s[0],
        n = s[s.length - 1];
      e.shiftKey && document.activeElement === i
        ? (e.preventDefault(), n.focus())
        : e.shiftKey ||
          document.activeElement !== n ||
          (e.preventDefault(), i.focus());
    }
    closeModal(e) {
      e.classList.remove("active"), e.setAttribute("aria-hidden", "true");
      const t = document.querySelector(`[aria-controls="${e.id}"]`);
      t && t.focus();
    }
    carouselPrevious(e) {
      const t = e.querySelector(".carousel-prev, .slider-prev");
      t && t.click();
    }
    carouselNext(e) {
      const t = e.querySelector(".carousel-next, .slider-next");
      t && t.click();
    }
    carouselGoTo(e, t) {
      const s = e.querySelectorAll(".carousel-indicator, .slider-dot");
      s[t] && s[t].click();
    }
    getShortcuts() {
      const e = [];
      return (
        this.shortcuts.forEach((t, s) => {
          e.push({ key: s, description: t.description });
        }),
        e
      );
    }
  }
  "loading" === document.readyState
    ? document.addEventListener("DOMContentLoaded", () => {
        window.keyboardNavigation = new p();
      })
    : (window.keyboardNavigation = new p()),
    "undefined" != typeof module && module.exports && (module.exports = p);
  class f extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {}
    changeQuantity(e, t) {
      this.classList.add("cart-loading");
      const s = JSON.stringify({
        line: e,
        quantity: parseInt(t),
        sections: ["main-cart-items"],
        sections_url: window.location.pathname,
      });
      fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: s,
      })
        .then((e) => e.text())
        .then((t) => {
          try {
            const s = JSON.parse(t);
            if (s.errors) {
              console.error("Cart errors:", s.errors);
              const t = document.getElementById(`Quantity-${e}`);
              return void (t && (t.value = t.getAttribute("value")));
            }
            this.updateCartDisplay(s);
          } catch (e) {
            console.error("Error parsing cart response:", e),
              window.location.reload();
          }
        })
        .catch((t) => {
          console.error("Cart update failed:", t);
          const s = document.getElementById(`Quantity-${e}`);
          s && (s.value = s.getAttribute("value"));
        })
        .finally(() => {
          this.classList.remove("cart-loading");
        });
    }
    updateCartDisplay(e) {
      window.location.reload();
    }
    updateCartBadge(e) {
      const t = document.querySelector(".header__cart-badge");
      t &&
        (e > 0
          ? ((t.textContent = e), (t.style.display = "block"))
          : (t.style.display = "none"));
      document.querySelectorAll("[data-cart-count]").forEach((t) => {
        t.textContent = e;
      });
    }
  }
  customElements.get("cart-items-clean") ||
    customElements.define("cart-items-clean", f);
  const g = {
    formatPrice: (e, t = "USD") =>
      new Intl.NumberFormat("en-US", { style: "currency", currency: t }).format(
        e / 100
      ),
    getVariantById: (e, t) => e.variants.find((e) => e.id == t),
    getFirstAvailableVariant: (e) =>
      e.variants.find((e) => e.available) || e.variants[0],
    updatePriceDisplay(e, t) {
      if (!e || !t) return;
      const s = this.formatPrice(t.price),
        i = t.compare_at_price ? this.formatPrice(t.compare_at_price) : null;
      i && t.compare_at_price > t.price
        ? (e.innerHTML = `\n        <span class="price__sale">${s}</span>\n        <span class="price__regular">${i}</span>\n      `)
        : (e.innerHTML = `<span class="price__regular">${s}</span>`);
    },
    updateAvailabilityDisplay(e, t) {
      if (e && t)
        if (t.available) {
          const s = t.inventory_quantity;
          e.innerHTML =
            s <= 10 && s > 0
              ? `\n          <span class="inventory-status inventory-status--low-stock">\n            Only ${s} left in stock\n          </span>\n        `
              : s > 10
              ? '\n          <span class="inventory-status inventory-status--in-stock">\n            In stock\n          </span>\n        '
              : '\n          <span class="inventory-status inventory-status--out-of-stock">\n            Out of stock\n          </span>\n        ';
        } else
          e.innerHTML =
            '\n        <span class="inventory-status inventory-status--out-of-stock">\n          Out of stock\n        </span>\n      ';
    },
    updateVariantImage(e) {
      if (!e || !e.featured_image) return;
      const t = document.querySelector(".product-media-gallery");
      if (!t) return;
      const s = t.querySelector(".main-media img");
      s &&
        ((s.src = e.featured_image.src),
        (s.alt = e.featured_image.alt || e.title));
      t.querySelectorAll(".thumbnail-btn img").forEach((t, s) => {
        0 === s &&
          ((t.src = e.featured_image.src),
          (t.alt = e.featured_image.alt || e.title));
      });
    },
    validateQuantity(e, t = 1, s = 999) {
      const i = parseInt(e);
      return isNaN(i) || i < t ? t : i > s ? s : i;
    },
    announceToScreenReader(e, t = "polite") {
      const s = document.createElement("div");
      s.setAttribute("aria-live", t),
        s.setAttribute("aria-atomic", "true"),
        s.classList.add("sr-only"),
        (s.textContent = e),
        document.body.appendChild(s),
        setTimeout(() => {
          document.body.contains(s) && document.body.removeChild(s);
        }, 1e3);
    },
  };
  class b extends HTMLElement {
    constructor() {
      super(),
        (this.selects = []),
        (this.radios = []),
        (this.currentVariant = null);
    }
    connectedCallback() {
      (this.selects = this.querySelectorAll('select[name*="id"]')),
        (this.radios = this.querySelectorAll(
          'input[type="radio"][name*="id"]'
        )),
        this.setupEventListeners(),
        this.initializeVariant();
    }
    setupEventListeners() {
      this.selects.forEach((e) => {
        e.addEventListener("change", this.handleChange.bind(this));
      }),
        this.radios.forEach((e) => {
          e.addEventListener("change", this.handleChange.bind(this));
        });
    }
    handleChange() {
      const e = this.getSelectedVariantId();
      e && this.updateVariant(e);
    }
    getSelectedVariantId() {
      for (const e of this.selects) if (e.value) return e.value;
      for (const e of this.radios) if (e.checked) return e.value;
      return null;
    }
    async updateVariant(e) {
      try {
        const t = document.querySelector("#product-json");
        if (t) {
          const s = JSON.parse(t.textContent),
            i = g.getVariantById(s, e);
          i &&
            ((this.currentVariant = i),
            this.updateUI(i),
            this.dispatchEvent(
              new CustomEvent("variant:changed", {
                bubbles: !0,
                detail: { variant: i },
              })
            ));
        }
      } catch (e) {
        console.error("Error updating variant:", e);
      }
    }
    updateUI(e) {
      const t = document.querySelector(".product-price");
      t && g.updatePriceDisplay(t, e);
      const s = document.querySelector(".product-inventory");
      s && g.updateAvailabilityDisplay(s, e), g.updateVariantImage(e);
      const i = this.closest("form");
      if (i) {
        const t = i.querySelector('input[name="id"]');
        t && (t.value = e.id);
      }
    }
    initializeVariant() {
      const e = this.getSelectedVariantId();
      e && this.updateVariant(e);
    }
  }
  if (
    (customElements.get("variant-selector") ||
      customElements.define("variant-selector", b),
    (window.ProductUtils = g),
    "undefined" == typeof PredictiveSearch)
  ) {
    class e extends HTMLElement {
      constructor() {
        super(),
          (this.searchInput = null),
          (this.searchResults = null),
          (this.searchForm = null),
          (this.cache = new Map()),
          (this.currentRequest = null),
          (this.selectedIndex = -1),
          (this.isOpen = !1);
      }
      connectedCallback() {
        (this.searchInput = this.querySelector(".predictive-search__input")),
          (this.searchResults = this.querySelector(
            ".predictive-search__results"
          )),
          (this.searchForm = this.querySelector(".predictive-search__form")),
          this.setupSearch(),
          this.setupKeyboardNavigation();
      }
      setupSearch() {
        this.searchForm?.addEventListener("submit", (e) => {
          e.preventDefault(), this.performSearch();
        }),
          this.searchInput?.addEventListener(
            "input",
            this.debounce(() => {
              this.performSearch();
            }, 300)
          ),
          document.addEventListener("click", (e) => {
            this.contains(e.target) || this.closeResults();
          });
      }
      setupKeyboardNavigation() {
        this.searchInput?.addEventListener("keydown", (e) => {
          switch (e.key) {
            case "ArrowDown":
              e.preventDefault(), this.selectNext();
              break;
            case "ArrowUp":
              e.preventDefault(), this.selectPrevious();
              break;
            case "Enter":
              this.selectedIndex >= 0 &&
                (e.preventDefault(), this.selectResult(this.selectedIndex));
              break;
            case "Escape":
              this.closeResults();
          }
        });
      }
      async performSearch() {
        const e = this.searchInput?.value.trim();
        if (!e || e.length < 2) this.closeResults();
        else if (this.cache.has(e)) this.displayResults(this.cache.get(e));
        else {
          this.currentRequest && this.currentRequest.abort();
          try {
            this.currentRequest = new AbortController();
            const t = await fetch(
                `/search/suggest.json?q=${encodeURIComponent(e)}`,
                { signal: this.currentRequest.signal }
              ),
              s = await t.json(),
              i = s.resources?.results || [];
            this.cache.set(e, i), this.displayResults(i);
          } catch (e) {
            "AbortError" !== e.name && console.error("Search error:", e);
          }
        }
      }
      displayResults(e) {
        if (!this.searchResults) return;
        if (0 === e.length)
          return (
            (this.searchResults.innerHTML =
              '<p class="predictive-search__no-results">No results found</p>'),
            void this.openResults()
          );
        const t = e
          .map(
            (e, t) =>
              `\n        <a href="${
                e.url
              }" class="predictive-search__result-item" data-index="${t}">\n          <div class="predictive-search__result-image">\n            ${
                e.featured_image
                  ? `<img src="${e.featured_image}" alt="${e.title}">`
                  : ""
              }\n          </div>\n          <div class="predictive-search__result-content">\n            <h3 class="predictive-search__result-title">${
                e.title
              }</h3>\n            <p class="predictive-search__result-price">${
                e.price || ""
              }</p>\n          </div>\n        </a>\n      `
          )
          .join("");
        (this.searchResults.innerHTML = t),
          this.openResults(),
          (this.selectedIndex = -1);
      }
      openResults() {
        (this.isOpen = !0),
          this.searchResults?.classList.add("predictive-search__results--open");
      }
      closeResults() {
        (this.isOpen = !1),
          (this.selectedIndex = -1),
          this.searchResults?.classList.remove(
            "predictive-search__results--open"
          );
      }
      selectNext() {
        const e = this.searchResults?.querySelectorAll(
          ".predictive-search__result-item"
        );
        e &&
          0 !== e.length &&
          ((this.selectedIndex = Math.min(
            this.selectedIndex + 1,
            e.length - 1
          )),
          this.updateSelection(e));
      }
      selectPrevious() {
        const e = this.searchResults?.querySelectorAll(
          ".predictive-search__result-item"
        );
        e &&
          0 !== e.length &&
          ((this.selectedIndex = Math.max(this.selectedIndex - 1, -1)),
          this.updateSelection(e));
      }
      updateSelection(e) {
        e.forEach((e, t) => {
          e.classList.toggle(
            "predictive-search__result-item--selected",
            t === this.selectedIndex
          );
        }),
          this.selectedIndex >= 0 &&
            e[this.selectedIndex]?.scrollIntoView({ block: "nearest" });
      }
      selectResult(e) {
        const t = this.searchResults?.querySelectorAll(
          ".predictive-search__result-item"
        );
        t && t[e] && (window.location.href = t[e].href);
      }
      debounce(e, t = null) {
        const s = t || window.THEME_CONFIG?.ON_CHANGE_DEBOUNCE_TIMER || 300;
        let i;
        return function (...t) {
          clearTimeout(i),
            (i = setTimeout(() => {
              clearTimeout(i), e.apply(this, t);
            }, s));
        };
      }
    }
    customElements.get("predictive-search") ||
      customElements.define("predictive-search", e),
      (window.PredictiveSearch = e);
  }
  class y {
    constructor() {
      (this.isMobile = window.innerWidth <= 768), this.init();
    }
    init() {
      this.bindEvents(),
        this.loadSavedPreferences(),
        this.initPagination(),
        this.isMobile && this.forceCardViewOnMobile();
    }
    bindEvents() {
      const e = document.getElementById("sort-by");
      if (
        (e && e.addEventListener("change", this.handleSortChange.bind(this)),
        !this.isMobile)
      ) {
        document.querySelectorAll(".view-btn").forEach((e) => {
          e.addEventListener("click", this.handleViewChange.bind(this));
        });
      }
      const t = document.querySelector(".filters-toggle");
      t && t.addEventListener("click", this.toggleMobileFilters.bind(this)),
        window.addEventListener("resize", this.handleResize.bind(this));
    }
    handleResize() {
      const e = this.isMobile;
      (this.isMobile = window.innerWidth <= 768),
        e !== this.isMobile &&
          (this.isMobile
            ? this.forceCardViewOnMobile()
            : this.bindViewToggleEvents());
    }
    forceCardViewOnMobile() {
      const e = document.getElementById("products-grid");
      e &&
        (e.classList.remove("list-view"),
        e.classList.add("grid-cols-1", "sm:grid-cols-2", "lg:grid-cols-3"));
      const t = document.querySelectorAll(".grid-card"),
        s = document.querySelectorAll(".list-card");
      t.forEach((e) => e.classList.remove("hidden")),
        s.forEach((e) => e.classList.add("hidden"));
      document.querySelectorAll(".view-btn").forEach((e) => {
        e.classList.remove("active"),
          e.classList.contains("view-btn--grid") && e.classList.add("active");
      }),
        this.saveViewPreference("grid");
    }
    bindViewToggleEvents() {
      document.querySelectorAll(".view-btn").forEach((e) => {
        e.addEventListener("click", this.handleViewChange.bind(this));
      });
    }
    handleSortChange(e) {
      const t = e.target.value,
        s = new URL(window.location);
      "manual" === t
        ? s.searchParams.delete("sort_by")
        : s.searchParams.set("sort_by", t),
        s.searchParams.delete("page"),
        (window.location.href = s.toString());
    }
    handleViewChange(e) {
      const t = e.currentTarget.classList.contains("view-btn--list")
        ? "list"
        : "grid";
      (this.isMobile && "list" === t) || this.setView(t);
    }
    setView(e) {
      this.isMobile && "list" === e && (e = "grid");
      const t = document.getElementById("products-grid"),
        s = document.querySelectorAll(".view-btn"),
        i = document.querySelectorAll(".grid-card"),
        n = document.querySelectorAll(".list-card");
      t &&
        ("list" === e
          ? (t.classList.add("list-view"),
            t.classList.remove(
              "grid-cols-1",
              "sm:grid-cols-2",
              "lg:grid-cols-3"
            ),
            i.forEach((e) => e.classList.add("hidden")),
            n.forEach((e) => e.classList.remove("hidden")))
          : (t.classList.remove("list-view"),
            t.classList.add("grid-cols-1", "sm:grid-cols-2", "lg:grid-cols-3"),
            i.forEach((e) => e.classList.remove("hidden")),
            n.forEach((e) => e.classList.add("hidden"))),
        s.forEach((t) => {
          t.classList.remove("active"),
            t.classList.contains(`view-btn--${e}`) && t.classList.add("active");
        }),
        this.saveViewPreference(e));
    }
    toggleMobileFilters() {}
    saveViewPreference(e) {
      try {
        localStorage.setItem("collection-view", e);
      } catch (e) {
        console.warn("Could not save view preference:", e);
      }
    }
    loadSavedPreferences() {
      try {
        if (this.isMobile) return void this.forceCardViewOnMobile();
        const e = localStorage.getItem("collection-view");
        !e || ("list" !== e && "grid" !== e) || this.setView(e);
      } catch (e) {
        console.warn("Could not load saved preferences:", e);
      }
    }
    updateUrlParameter(e, t) {
      const s = new URL(window.location);
      return (
        t ? s.searchParams.set(e, t) : s.searchParams.delete(e), s.toString()
      );
    }
    initPagination() {
      window.PaginationManager &&
        (this.paginationManager = new window.PaginationManager());
    }
    async loadProducts(e = {}) {
      try {
        const t = new URL(window.location);
        Object.keys(e).forEach((s) => {
          e[s] ? t.searchParams.set(s, e[s]) : t.searchParams.delete(s);
        }),
          t.searchParams.set("section_id", "collection-template");
        const s = await fetch(t.toString(), {
          headers: { "X-Requested-With": "XMLHttpRequest" },
        });
        if (!s.ok) throw new Error(`HTTP error! status: ${s.status}`);
        const i = await s.text(),
          n = new DOMParser().parseFromString(i, "text/html"),
          o = n.getElementById("products-grid"),
          r = document.getElementById("products-grid");
        if (o && r) {
          r.innerHTML = o.innerHTML;
          const e = n.querySelector(".pagination-wrapper"),
            t = document.querySelector(".pagination-wrapper");
          e && t ? (t.innerHTML = e.innerHTML) : t && !e && t.remove();
        }
        window.history.pushState(
          {},
          "",
          t.toString().replace("&section_id=collection-template", "")
        );
      } catch (t) {
        console.error("Error loading products:", t),
          (window.location.href = this.updateUrlParameter(
            "sort_by",
            e.sort_by
          ));
      }
    }
  }
  (window.setView = function (e) {
    window.collectionManager && window.collectionManager.setView(e);
  }),
    (window.toggleFilters = function () {
      window.collectionManager &&
        window.collectionManager.toggleMobileFilters();
    }),
    document.addEventListener("DOMContentLoaded", function () {
      window.collectionManager = new y();
    }),
    window.addEventListener("popstate", function (e) {
      window.location.reload();
    });
  class v extends HTMLElement {
    constructor() {
      super(), this.setupEventListeners();
    }
    setupEventListeners() {
      this.querySelectorAll('[data-address=""]').forEach((e) => {
        e.addEventListener(
          "click",
          this.openAddressModal.bind(this, "AddAddress")
        );
      });
      this.querySelectorAll('[data-address]:not([data-address=""])').forEach(
        (e) => {
          e.addEventListener("click", (e) => {
            const t = JSON.parse(e.target.getAttribute("data-address"));
            this.openAddressModal("EditAddress", t);
          });
        }
      );
      this.querySelectorAll("[data-target][data-confirm-message]").forEach(
        (e) => {
          e.addEventListener("click", this.handleDeleteAddress.bind(this));
        }
      );
      this.querySelectorAll(
        ".address-form-modal__close, .address-form__cancel"
      ).forEach((e) => {
        e.addEventListener("click", this.closeAddressModal.bind(this));
      }),
        this.setupCountryProvinceSelectors();
    }
    openAddressModal(e, t = null) {
      const s = document.getElementById(e);
      if (!s) return;
      t && "EditAddress" === e && this.populateEditForm(t),
        s.removeAttribute("hidden"),
        s.setAttribute("aria-hidden", "false");
      const i = s.querySelector("input");
      i && i.focus(), (document.body.style.overflow = "hidden");
    }
    closeAddressModal() {
      document.querySelectorAll(".address-form-modal").forEach((e) => {
        e.setAttribute("hidden", ""), e.setAttribute("aria-hidden", "true");
      }),
        (document.body.style.overflow = "");
    }
    populateEditForm(e) {
      const t = document.querySelector("#EditAddress form");
      if (!t) return;
      t.action = `/account/addresses/${e.id}`;
      const s = {
        AddressFirstNameEdit: e.first_name,
        AddressLastNameEdit: e.last_name,
        AddressCompanyEdit: e.company,
        AddressAddress1Edit: e.address1,
        AddressAddress2Edit: e.address2,
        AddressCityEdit: e.city,
        AddressZipEdit: e.zip,
        AddressPhoneEdit: e.phone,
      };
      Object.entries(s).forEach(([e, t]) => {
        const s = document.getElementById(e);
        s && t && (s.value = t);
      });
      const i = document.getElementById("AddressCountryEdit"),
        n = document.getElementById("AddressProvinceContainerEdit"),
        o = document.getElementById("AddressProvinceEdit");
      i &&
        e.country &&
        ((i.value = e.country),
        this.updateProvinceOptions(i, o, n, e.province));
    }
    handleDeleteAddress(e) {
      const t = e.target.getAttribute("data-target"),
        s = e.target.getAttribute("data-confirm-message");
      if (confirm(s)) {
        const e = document.createElement("form");
        (e.method = "post"), (e.action = t);
        const s = document.createElement("input");
        (s.type = "hidden"), (s.name = "_method"), (s.value = "delete");
        const i = document.createElement("input");
        (i.type = "hidden"),
          (i.name = "authenticity_token"),
          (i.value =
            document
              .querySelector('meta[name="csrf-token"]')
              ?.getAttribute("content") || ""),
          e.appendChild(s),
          e.appendChild(i),
          document.body.appendChild(e),
          e.submit();
      }
    }
    setupCountryProvinceSelectors() {
      const e = document.getElementById("AddressCountryNew"),
        t = document.getElementById("AddressProvinceNew"),
        s = document.getElementById("AddressProvinceContainerNew");
      e &&
        e.addEventListener("change", () => {
          this.updateProvinceOptions(e, t, s);
        });
      const i = document.getElementById("AddressCountryEdit"),
        n = document.getElementById("AddressProvinceEdit"),
        o = document.getElementById("AddressProvinceContainerEdit");
      i &&
        i.addEventListener("change", () => {
          this.updateProvinceOptions(i, n, o);
        });
    }
    updateProvinceOptions(e, t, s, i = null) {
      const n = e.value;
      if (!n || !window.Countries || !window.Countries[n])
        return void (s.style.display = "none");
      const o = window.Countries[n].provinces;
      o && 0 !== o.length
        ? ((t.innerHTML = ""),
          o.forEach((e) => {
            const s = document.createElement("option");
            (s.value = e[0]),
              (s.textContent = e[1]),
              i && e[0] === i && (s.selected = !0),
              t.appendChild(s);
          }),
          (s.style.display = "block"))
        : (s.style.display = "none");
    }
  }
  if (
    (document.addEventListener("DOMContentLoaded", () => {
      document.querySelector(".customer.addresses") && new v();
    }),
    document.addEventListener("click", (e) => {
      if (e.target.classList.contains("address-form-modal")) {
        const t = e.target.querySelector(".address-form-modal__close");
        t && t.click();
      }
    }),
    document.addEventListener("keydown", (e) => {
      if ("Escape" === e.key) {
        const e = document.querySelector(".address-form-modal:not([hidden])");
        if (e) {
          const t = e.querySelector(".address-form-modal__close");
          t && t.click();
        }
      }
    }),
    (window.Countries = window.Countries || {}),
    (window.Countries = {
      "United States": {
        provinces: [
          ["AL", "Alabama"],
          ["AK", "Alaska"],
          ["AZ", "Arizona"],
          ["AR", "Arkansas"],
          ["CA", "California"],
          ["CO", "Colorado"],
          ["CT", "Connecticut"],
          ["DE", "Delaware"],
          ["FL", "Florida"],
          ["GA", "Georgia"],
          ["HI", "Hawaii"],
          ["ID", "Idaho"],
          ["IL", "Illinois"],
          ["IN", "Indiana"],
          ["IA", "Iowa"],
          ["KS", "Kansas"],
          ["KY", "Kentucky"],
          ["LA", "Louisiana"],
          ["ME", "Maine"],
          ["MD", "Maryland"],
          ["MA", "Massachusetts"],
          ["MI", "Michigan"],
          ["MN", "Minnesota"],
          ["MS", "Mississippi"],
          ["MO", "Missouri"],
          ["MT", "Montana"],
          ["NE", "Nebraska"],
          ["NV", "Nevada"],
          ["NH", "New Hampshire"],
          ["NJ", "New Jersey"],
          ["NM", "New Mexico"],
          ["NY", "New York"],
          ["NC", "North Carolina"],
          ["ND", "North Dakota"],
          ["OH", "Ohio"],
          ["OK", "Oklahoma"],
          ["OR", "Oregon"],
          ["PA", "Pennsylvania"],
          ["RI", "Rhode Island"],
          ["SC", "South Carolina"],
          ["SD", "South Dakota"],
          ["TN", "Tennessee"],
          ["TX", "Texas"],
          ["UT", "Utah"],
          ["VT", "Vermont"],
          ["VA", "Virginia"],
          ["WA", "Washington"],
          ["WV", "West Virginia"],
          ["WI", "Wisconsin"],
          ["WY", "Wyoming"],
        ],
      },
      Canada: {
        provinces: [
          ["AB", "Alberta"],
          ["BC", "British Columbia"],
          ["MB", "Manitoba"],
          ["NB", "New Brunswick"],
          ["NL", "Newfoundland and Labrador"],
          ["NT", "Northwest Territories"],
          ["NS", "Nova Scotia"],
          ["NU", "Nunavut"],
          ["ON", "Ontario"],
          ["PE", "Prince Edward Island"],
          ["QC", "Quebec"],
          ["SK", "Saskatchewan"],
          ["YT", "Yukon"],
        ],
      },
    }),
    "undefined" == typeof MediaGallery)
  ) {
    class e extends HTMLElement {
      constructor() {
        super(),
          (this.mainImage = null),
          (this.thumbnails = []),
          (this.currentIndex = 0),
          (this.zoomEnabled = !1);
      }
      connectedCallback() {
        (this.mainImage = this.querySelector(".media-gallery__main-image")),
          (this.thumbnails = Array.from(
            this.querySelectorAll(".media-gallery__thumbnail")
          )),
          this.setupThumbnails(),
          this.setupZoom(),
          this.setupKeyboardNavigation();
      }
      setupThumbnails() {
        this.thumbnails.forEach((e, t) => {
          e.addEventListener("click", () => this.selectImage(t)),
            e.addEventListener("keydown", (e) => {
              ("Enter" !== e.key && " " !== e.key) ||
                (e.preventDefault(), this.selectImage(t));
            });
        });
      }
      setupZoom() {
        this.mainImage &&
          (this.mainImage.addEventListener("mouseenter", () => {
            (this.zoomEnabled = !0),
              this.mainImage.classList.add(
                "media-gallery__main-image--zoom-enabled"
              );
          }),
          this.mainImage.addEventListener("mouseleave", () => {
            (this.zoomEnabled = !1),
              this.mainImage.classList.remove(
                "media-gallery__main-image--zoom-enabled"
              );
          }),
          this.mainImage.addEventListener("mousemove", (e) => {
            this.zoomEnabled && this.handleZoom(e);
          }));
      }
      setupKeyboardNavigation() {
        this.addEventListener("keydown", (e) => {
          switch (e.key) {
            case "ArrowLeft":
              e.preventDefault(), this.previousImage();
              break;
            case "ArrowRight":
              e.preventDefault(), this.nextImage();
              break;
            case "Home":
              e.preventDefault(), this.selectImage(0);
              break;
            case "End":
              e.preventDefault(), this.selectImage(this.thumbnails.length - 1);
          }
        });
      }
      selectImage(e) {
        if (e < 0 || e >= this.thumbnails.length) return;
        this.currentIndex = e;
        const t = this.thumbnails[e],
          s = t.dataset.fullImage || t.src;
        this.mainImage &&
          ((this.mainImage.src = s), (this.mainImage.alt = t.alt || "")),
          this.thumbnails.forEach((t, s) => {
            t.classList.toggle("media-gallery__thumbnail--active", s === e),
              t.setAttribute("aria-current", s === e ? "true" : "false");
          }),
          t.focus(),
          this.dispatchEvent(
            new CustomEvent("media-gallery:image-changed", {
              detail: { index: e, imageSrc: s },
            })
          );
      }
      previousImage() {
        const e =
          this.currentIndex > 0
            ? this.currentIndex - 1
            : this.thumbnails.length - 1;
        this.selectImage(e);
      }
      nextImage() {
        const e =
          this.currentIndex < this.thumbnails.length - 1
            ? this.currentIndex + 1
            : 0;
        this.selectImage(e);
      }
      handleZoom(e) {
        if (!this.mainImage) return;
        const t = this.mainImage.getBoundingClientRect(),
          s = (e.clientX - t.left) / t.width,
          i = (e.clientY - t.top) / t.height;
        this.mainImage.style.transformOrigin = `${100 * s}% ${100 * i}%`;
      }
    }
    customElements.get("media-gallery") ||
      customElements.define("media-gallery", e),
      (window.MediaGallery = e);
  }
  !(function () {
    function e() {
      document.addEventListener("click", function (e) {
        if (e.target.closest(".quick-add-btn")) {
          e.preventDefault();
          const s = e.target.closest(".quick-add-btn"),
            i = s.dataset.variantId;
          i ? t(i, s) : console.warn("Quick add button missing variant ID");
        }
      });
    }
    function t(e, t) {
      const s = t.innerHTML;
      (t.disabled = !0),
        (t.innerHTML =
          '\n      <svg class="w-4 h-4 mr-2 animate-spin" fill="none" viewBox="0 0 24 24">\n        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>\n        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>\n      </svg>\n      Adding...\n    ');
      const i = { items: [{ id: e.toString(), quantity: 1 }] };
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify(i),
      })
        .then((e) =>
          e.ok
            ? e.json()
            : e.text().then((t) => {
                throw (
                  (console.error("Quick add failed:", e.status, t),
                  new Error(`HTTP error! status: ${e.status}`))
                );
              })
        )
        .then((e) =>
          void 0 === e.item_count ? fetch("/cart.js").then((e) => e.json()) : e
        )
        .then((e) => {
          !(function (e, t) {
            (e.innerHTML =
              '\n      <svg class="w-4 h-4 mr-2 text-green-500" fill="currentColor" viewBox="0 0 20 20">\n        <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>\n      </svg>\n      Added!\n    '),
              e.classList.add("bg-green-500", "hover:bg-green-600"),
              e.classList.remove("bg-primary", "hover:bg-primary-dark"),
              setTimeout(() => {
                (e.disabled = !1),
                  (e.innerHTML = t),
                  e.classList.remove("bg-green-500", "hover:bg-green-600"),
                  e.classList.add("bg-primary", "hover:bg-primary-dark");
              }, 2e3);
          })(t, s),
            (function (e) {
              let t = e.item_count;
              void 0 === t &&
                e.items &&
                Array.isArray(e.items) &&
                (t = e.items.reduce((e, t) => e + (t.quantity || 0), 0));
              const s = document.querySelectorAll(
                ".cart-count, [data-cart-count], .header__cart-badge"
              );
              if (0 === s.length) {
                const e = document.querySelector(".header__cart-button");
                if (e && t > 0) {
                  const s = document.createElement("span");
                  (s.className = "header__cart-badge"),
                    (s.textContent = t),
                    e.appendChild(s);
                }
              } else
                s.forEach((e) => {
                  void 0 !== t &&
                    ((e.textContent = t), e.classList.remove("hidden"));
                });
              const i = document.querySelector("cart-drawer");
              i && "function" == typeof i.renderContents && i.renderContents(e);
            })(e),
            document.dispatchEvent(
              new CustomEvent("cart:updated", { detail: { cart: e } })
            );
        })
        .catch((e) => {
          console.error("Error adding to cart:", e),
            (function (e, t) {
              (e.innerHTML =
                '\n      <svg class="w-4 h-4 mr-2 text-red-500" fill="currentColor" viewBox="0 0 20 20">\n        <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>\n      </svg>\n      Error\n    '),
                e.classList.add("bg-red-500", "hover:bg-red-600"),
                e.classList.remove("bg-primary", "hover:bg-primary-dark"),
                setTimeout(() => {
                  (e.disabled = !1),
                    (e.innerHTML = t),
                    e.classList.remove("bg-red-500", "hover:bg-red-600"),
                    e.classList.add("bg-primary", "hover:bg-primary-dark");
                }, 3e3);
            })(t, s);
        });
    }
    document.addEventListener("DOMContentLoaded", function () {
      e();
    }),
      (window.QuickAdd = { init: e, addToCart: t });
  })();
  class w {
    constructor() {
      (this.menu = null),
        (this.toggleButton = null),
        (this.closeButton = null),
        (this.isOpen = !1),
        this.init();
    }
    init() {
      (this.menu = document.getElementById("mobile-menu")),
        (this.toggleButton = document.querySelector(
          "[data-mobile-menu-toggle]"
        )),
        (this.closeButton = document.querySelector(".mobile-menu__close")),
        this.menu && this.toggleButton
          ? (this.bindEvents(), this.setupAccessibility())
          : console.warn("Mobile menu elements not found");
    }
    bindEvents() {
      this.toggleButton.addEventListener("click", (e) => {
        e.preventDefault(), this.toggle();
      }),
        this.closeButton &&
          this.closeButton.addEventListener("click", (e) => {
            e.preventDefault(), this.close();
          }),
        document.addEventListener("keydown", (e) => {
          "Escape" === e.key && this.isOpen && this.close();
        }),
        this.menu.addEventListener("click", (e) => {
          e.target === this.menu && this.close();
        });
      this.menu.querySelectorAll("a").forEach((e) => {
        e.addEventListener("click", () => {
          this.close();
        });
      });
    }
    setupAccessibility() {
      this.menu.setAttribute("aria-hidden", "true"),
        this.toggleButton.setAttribute("aria-expanded", "false"),
        this.toggleButton.setAttribute("aria-label", "Open mobile menu");
    }
    toggle() {
      this.isOpen ? this.close() : this.open();
    }
    open() {
      if (!this.isOpen) {
        if (
          ((this.isOpen = !0),
          (this.scrollPosition =
            window.pageYOffset || document.documentElement.scrollTop),
          this.menu.setAttribute("aria-hidden", "false"),
          this.toggleButton.setAttribute("aria-expanded", "true"),
          this.toggleButton.setAttribute("aria-label", "Close mobile menu"),
          this.menu.classList.add("mobile-menu--open"),
          document.body.classList.add("mobile-menu-open"),
          (document.body.style.top = `-${this.scrollPosition}px`),
          this.closeButton)
        ) {
          setTimeout(() => this.closeButton.focus(), 100);
        }
        this.emitEvent("mobileMenuOpened");
      }
    }
    close() {
      if (this.isOpen) {
        if (
          ((this.isOpen = !1),
          this.menu.setAttribute("aria-hidden", "true"),
          this.toggleButton.setAttribute("aria-expanded", "false"),
          this.toggleButton.setAttribute("aria-label", "Open mobile menu"),
          this.menu.classList.remove("mobile-menu--open"),
          document.body.classList.remove("mobile-menu-open"),
          (document.body.style.top = ""),
          void 0 !== this.scrollPosition &&
            window.scrollTo(0, this.scrollPosition),
          this.toggleButton)
        ) {
          setTimeout(() => this.toggleButton.focus(), 100);
        }
        this.emitEvent("mobileMenuClosed");
      }
    }
    emitEvent(e) {
      const t = new CustomEvent(e, { detail: { isOpen: this.isOpen } });
      document.dispatchEvent(t);
    }
  }
  document.addEventListener("DOMContentLoaded", () => {
    window.mobileMenu = new w();
  });
  class E {
    constructor() {
      (this.icons = []), this.init();
    }
    init() {
      "loading" === document.readyState
        ? document.addEventListener("DOMContentLoaded", () => this.setupIcons())
        : this.setupIcons();
    }
    setupIcons() {
      if (
        ((this.icons = document.querySelectorAll(".guarantee-icon-float")),
        0 === this.icons.length)
      )
        return;
      const e = [
        { x: -1, y: -1 },
        { x: 1, y: 1 },
        { x: -1, y: 1 },
        { x: 1, y: -1 },
        { x: -1, y: -1 },
        { x: 1, y: 0 },
      ];
      this.icons.forEach((t, s) => {
        const i = e[s % e.length],
          n = t.style.transform || "";
        t.addEventListener("mouseenter", (e) => {
          this.handleHoverEnter(e.target, i, n);
        }),
          t.addEventListener("mouseleave", (e) => {
            this.handleHoverLeave(e.target, n);
          }),
          t.addEventListener("click", (e) => {});
      });
    }
    handleHoverEnter(e, t, s) {
      e.style.setProperty("--hover-x", `${t.x}px`),
        e.style.setProperty("--hover-y", `${t.y}px`),
        e.classList.add("guarantee-icon-hover"),
        (e.style.opacity = "0.9"),
        (e.style.zIndex = "999999");
      const i = `${s} translateX(${t.x}px) translateY(${t.y}px) translateY(-2px) scale(1.02)`;
      e.style.setProperty("transform", i, "important"),
        e.style.setProperty(
          "transition",
          "all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1)",
          "important"
        );
    }
    handleHoverLeave(e, t) {
      e.classList.remove("guarantee-icon-hover"),
        (e.style.opacity = "0.6"),
        (e.style.zIndex = ""),
        e.style.setProperty("transform", t, "important"),
        e.style.setProperty(
          "transition",
          "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
          "important"
        );
    }
  }
  document.addEventListener("DOMContentLoaded", () => {
    new E();
  }),
    "loading" !== document.readyState && new E();
  class S {
    constructor() {
      (this.container = null),
        (this.scrollContainer = null),
        (this.items = []),
        (this.isAnimating = !1),
        (this.animationId = null),
        (this.isPaused = !1),
        (this.targetSpeed = 60),
        (this.currentSpeed = 60),
        (this.pauseTransitionDuration = 300),
        (this.resumeTransitionDuration = 500),
        this.init();
    }
    init() {
      (this.container = document.querySelector(".creators-carousel")),
        this.container
          ? ((this.scrollContainer = this.container.querySelector(".flex")),
            this.scrollContainer
              ? ((this.items = this.scrollContainer.querySelectorAll("div")),
                0 !== this.items.length
                  ? this.waitForImages().then(() => {
                      this.setupHoverEvents(), this.startAnimation();
                    })
                  : console.warn("🎠 CreatorsCarousel: No items found!"))
              : console.warn(
                  "🎠 CreatorsCarousel: Scroll container not found!"
                ))
          : console.warn("🎠 CreatorsCarousel: Container not found!");
    }
    waitForImages() {
      const e = this.scrollContainer.querySelectorAll("img"),
        t = Array.from(e).map((e) =>
          e.complete
            ? Promise.resolve()
            : new Promise((t) => {
                e.addEventListener("load", t), e.addEventListener("error", t);
              })
        );
      return Promise.all(t);
    }
    setupHoverEvents() {
      this.container.addEventListener("mouseenter", () => {
        this.pauseSmooth();
      }),
        this.container.addEventListener("mouseleave", () => {
          this.resumeSmooth();
        });
    }
    pauseSmooth() {
      (this.isPaused = !0),
        (this.targetSpeed = 0),
        this.animateSpeedTransition(this.pauseTransitionDuration);
    }
    resumeSmooth() {
      (this.isPaused = !1),
        (this.targetSpeed = 60),
        this.animateSpeedTransition(this.resumeTransitionDuration);
    }
    animateSpeedTransition(e) {
      const t = this.currentSpeed,
        s = this.targetSpeed,
        i = performance.now(),
        n = (o) => {
          const r = o - i,
            a = Math.min(r / e, 1),
            c = this.easeInOut(a);
          (this.currentSpeed = t + (s - t) * c),
            a < 1 && requestAnimationFrame(n);
        };
      requestAnimationFrame(n);
    }
    startAnimation() {
      this.isAnimating || ((this.isAnimating = !0), this.animate());
    }
    animate() {
      if (!this.isAnimating) return;
      const e = this.scrollContainer.scrollWidth / 2;
      let t = 0,
        s = performance.now();
      const i = (n) => {
        if (!this.isAnimating) return;
        if (document.hidden)
          return void (this.animationId = requestAnimationFrame(i));
        const o = n - s;
        (s = n), (t += (this.currentSpeed * o) / 1e3), t >= e && (t -= e);
        const r = Math.round(100 * t) / 100;
        (this.scrollContainer.style.transform = `translate3d(-${r}px, 0, 0)`),
          (this.animationId = requestAnimationFrame(i));
      };
      this.animationId = requestAnimationFrame(i);
    }
    easeInOut(e) {
      return e < 0.5 ? 2 * e * e : (4 - 2 * e) * e - 1;
    }
    stop() {
      (this.isAnimating = !1),
        this.scrollContainer &&
          (this.scrollContainer.style.transform = "translateX(0)"),
        this.animationId &&
          (cancelAnimationFrame(this.animationId), (this.animationId = null));
    }
    pause() {
      this.isAnimating = !1;
    }
    resume() {
      this.startAnimation();
    }
  }
  let A = null;
  document.addEventListener("DOMContentLoaded", () => {
    A || (A = new S());
  }),
    document.addEventListener("shopify:section:load", () => {
      A && A.stop(), (A = new S());
    });
  class L {
    constructor() {
      (this.selector = document.querySelector("[data-game-selector-toggle]")),
        (this.dropdown = document.querySelector(".header__game-dropdown")),
        (this.options = document.querySelectorAll(".header__game-option")),
        (this.isOpen = !1),
        this.selector && this.dropdown && this.init();
    }
    init() {
      this.bindEvents(), this.setupAccessibility(), this.setupMobileDropdown();
    }
    bindEvents() {
      this.selector.addEventListener("click", (e) => {
        e.preventDefault(), e.stopPropagation(), this.toggle();
      }),
        document.addEventListener("click", (e) => {
          this.selector.contains(e.target) ||
            this.dropdown.contains(e.target) ||
            this.close();
        }),
        this.selector.addEventListener("keydown", (e) => {
          "Enter" === e.key || " " === e.key
            ? (e.preventDefault(), this.toggle())
            : "Escape" === e.key && this.close();
        }),
        this.dropdown.addEventListener("keydown", (e) => {
          this.handleDropdownKeyboard(e);
        }),
        this.options.forEach((e) => {
          e.addEventListener("click", (e) => {
            this.close();
          });
        }),
        window.addEventListener("resize", () => {
          this.close();
        });
    }
    setupAccessibility() {
      this.selector.setAttribute("aria-haspopup", "true"),
        this.selector.setAttribute("aria-expanded", "false"),
        this.dropdown.setAttribute("role", "menu"),
        this.dropdown.setAttribute("aria-label", "Select a game"),
        this.options.forEach((e) => {
          e.setAttribute("role", "menuitem");
        });
    }
    setupMobileDropdown() {
      const e = () => {
          if (this.isOpen) {
            this.selector.getBoundingClientRect();
            const e = window.innerWidth <= 767,
              t = window.innerWidth >= 768 && window.innerWidth <= 1023;
            e || t
              ? ((this.dropdown.style.position = "absolute"),
                (this.dropdown.style.top = "100%"),
                (this.dropdown.style.left = "0"),
                (this.dropdown.style.right = "auto"),
                (this.dropdown.style.width = "auto"),
                (this.dropdown.style.minWidth = "200px"))
              : ((this.dropdown.style.position = ""),
                (this.dropdown.style.top = ""),
                (this.dropdown.style.left = ""),
                (this.dropdown.style.right = ""),
                (this.dropdown.style.width = ""),
                (this.dropdown.style.minWidth = ""));
          }
        },
        t = this.open.bind(this);
      (this.open = () => {
        t(), e();
      }),
        window.addEventListener("resize", e);
    }
    toggle() {
      this.isOpen ? this.close() : this.open();
    }
    open() {
      (this.isOpen = !0),
        this.dropdown.classList.add("active"),
        this.selector.setAttribute("aria-expanded", "true");
      const e = this.options[0];
      e && e.focus();
    }
    close() {
      (this.isOpen = !1),
        this.dropdown.classList.remove("active"),
        this.selector.setAttribute("aria-expanded", "false");
    }
    handleDropdownKeyboard(e) {
      const t = e.target.closest(".header__game-option"),
        s = Array.from(this.options),
        i = s.indexOf(t);
      switch (e.key) {
        case "ArrowDown":
          e.preventDefault();
          s[(i + 1) % s.length].focus();
          break;
        case "ArrowUp":
          e.preventDefault();
          s[0 === i ? s.length - 1 : i - 1].focus();
          break;
        case "Escape":
          e.preventDefault(), this.close();
      }
    }
  }
  document.addEventListener("DOMContentLoaded", () => {
    new L();
  }),
    (window.GameSelector = L);
  class C {
    constructor() {
      (this.notifications = []), (this.container = null), this.init();
    }
    init() {
      this.createContainer(), this.setupEventListeners();
    }
    createContainer() {
      (this.container = document.createElement("div")),
        (this.container.className = "cart-notifications-container"),
        (this.container.style.cssText =
          "\n      position: fixed;\n      top: 20px;\n      right: 20px;\n      z-index: 10000;\n      display: flex;\n      flex-direction: column;\n      gap: 10px;\n      pointer-events: none;\n    "),
        document.body.appendChild(this.container);
    }
    setupEventListeners() {
      document.addEventListener("cart:updated", (e) => {
        this.showNotification(e.detail);
      }),
        document.addEventListener("cart:error", (e) => {
          this.showError(e.detail);
        });
    }
    showNotification(e) {
      const t = this.createNotification(e, "success");
      this.addNotification(t);
    }
    showError(e) {
      const t = this.createNotification(e, "error");
      this.addNotification(t);
    }
    createNotification(e, t = "success") {
      const s = document.createElement("div");
      s.className = `cart-notification cart-notification--${t}`;
      const i = this.buildNotificationContent(e, t);
      return (
        (s.innerHTML = i),
        (s.style.cssText = `\n      background: ${
          "success" === t ? "#10b981" : "#ef4444"
        };\n      color: white;\n      padding: 12px 16px;\n      border-radius: 8px;\n      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n      font-size: 14px;\n      font-weight: 500;\n      max-width: 300px;\n      pointer-events: auto;\n    `),
        s
      );
    }
    buildNotificationContent(e, t) {
      return `\n      <div class="cart-notification__content">\n        <div class="cart-notification__header">\n          <span class="cart-notification__icon">${
        "success" === t ? "✓" : "✕"
      }</span>\n          <span class="cart-notification__title">${
        "success" === t ? "Added to cart" : "Error"
      }</span>\n        </div>\n        ${
        e.message
          ? `<div class="cart-notification__message">${e.message}</div>`
          : ""
      }\n        ${
        e.product
          ? `\n          <div class="cart-notification__product">\n            <img src="${e.product.image}" alt="${e.product.title}" style="width: 40px; height: 40px; object-fit: cover; border-radius: 4px;">\n            <div class="cart-notification__product-info">\n              <div class="cart-notification__product-title">${e.product.title}</div>\n              <div class="cart-notification__product-price">${e.product.price}</div>\n            </div>\n          </div>\n        `
          : ""
      }\n      </div>\n    `;
    }
    addNotification(e) {
      this.container.appendChild(e),
        this.notifications.push(e),
        requestAnimationFrame(() => {
          e.classList.add("section-fade-in", "fade-in-visible");
        });
      setTimeout(() => {
        this.removeNotification(e);
      }, 4e3);
    }
    removeNotification(e) {
      e.classList.remove("fade-in-visible");
      setTimeout(() => {
        e.parentNode && e.parentNode.removeChild(e);
        const t = this.notifications.indexOf(e);
        t > -1 && this.notifications.splice(t, 1);
      }, 300);
    }
    show(e, t = "success", s = null) {
      const i = s || 4e3,
        n = this.createNotification({ message: e }, t);
      this.addNotification(n),
        4e3 !== i &&
          setTimeout(() => {
            this.removeNotification(n);
          }, i);
    }
    showSuccess(e, t) {
      this.show(e, "success", t);
    }
    showError(e, t) {
      this.show(e, "error", t);
    }
    clear() {
      this.notifications.forEach((e) => {
        this.removeNotification(e);
      });
    }
    destroy() {
      this.clear(),
        this.container &&
          this.container.parentNode &&
          this.container.parentNode.removeChild(this.container);
    }
  }
  const k = new C();
  "undefined" != typeof module && module.exports
    ? (module.exports = C)
    : ((window.CartNotification = C), (window.cartNotification = k));
  class x extends HTMLElement {
    constructor() {
      super(),
        (this.input = null),
        (this.decreaseButton = null),
        (this.increaseButton = null),
        (this.min = 1),
        (this.max = null),
        (this.step = 1);
    }
    connectedCallback() {
      this.setupDOM(),
        this.setupEventListeners(),
        this.setupAccessibility(),
        this.updateButtonStates();
    }
    disconnectedCallback() {
      this.cleanup();
    }
    setupDOM() {
      (this.input = this.querySelector('input[type="number"]')),
        (this.decreaseButton = this.querySelector(
          '.quantity-decrease, [data-action="decrease"], [name="minus"], .quantity__button[name="minus"]'
        )),
        (this.increaseButton = this.querySelector(
          '.quantity-increase, [data-action="increase"], [name="plus"], .quantity__button[name="plus"]'
        )),
        (this.min = parseInt(
          this.input?.getAttribute("min") || this.getAttribute("min") || "1"
        )),
        (this.max =
          parseInt(
            this.input?.getAttribute("max") || this.getAttribute("max")
          ) || null),
        (this.step = parseInt(
          this.input?.getAttribute("step") || this.getAttribute("step") || "1"
        )),
        this.input &&
          (this.input.setAttribute("min", this.min.toString()),
          this.max && this.input.setAttribute("max", this.max.toString()),
          this.input.setAttribute("step", this.step.toString()));
    }
    setupEventListeners() {
      this.input &&
        (this.input.addEventListener("input", this.handleInput.bind(this)),
        this.input.addEventListener("change", this.handleChange.bind(this)),
        this.input.addEventListener("blur", this.handleBlur.bind(this)),
        this.input.addEventListener("keydown", this.handleKeydown.bind(this))),
        this.decreaseButton &&
          this.decreaseButton.addEventListener(
            "click",
            this.handleDecrease.bind(this)
          ),
        this.increaseButton &&
          this.increaseButton.addEventListener(
            "click",
            this.handleIncrease.bind(this)
          );
    }
    setupAccessibility() {
      if (
        (this.input &&
          (this.input.setAttribute("role", "spinbutton"),
          this.input.setAttribute("aria-label", "Quantity")),
        this.decreaseButton &&
          (this.decreaseButton.setAttribute("aria-label", "Decrease quantity"),
          this.decreaseButton.setAttribute("type", "button")),
        this.increaseButton &&
          (this.increaseButton.setAttribute("aria-label", "Increase quantity"),
          this.increaseButton.setAttribute("type", "button")),
        !this.querySelector("[aria-live]"))
      ) {
        const e = document.createElement("div");
        e.setAttribute("aria-live", "polite"),
          e.setAttribute("aria-atomic", "true"),
          (e.className = "visually-hidden"),
          (e.id = `quantity-live-${Math.random().toString(36).substr(2, 9)}`),
          this.appendChild(e);
      }
    }
    handleInput(e) {
      const t = parseInt(e.target.value);
      isNaN(t) || t < this.min
        ? this.input.classList.add("quantity-input--invalid")
        : this.input.classList.remove("quantity-input--invalid"),
        this.updateButtonStates();
    }
    handleChange(e) {
      this.validateAndUpdate();
    }
    handleBlur(e) {
      this.validateAndUpdate();
    }
    handleKeydown(e) {
      switch (e.key) {
        case "ArrowUp":
          e.preventDefault(), this.changeQuantity(this.step);
          break;
        case "ArrowDown":
          e.preventDefault(), this.changeQuantity(-this.step);
          break;
        case "Enter":
          e.preventDefault(), this.validateAndUpdate();
      }
    }
    handleDecrease(e) {
      e.preventDefault(), this.changeQuantity(-this.step);
    }
    handleIncrease(e) {
      e.preventDefault(), this.changeQuantity(this.step);
    }
    changeQuantity(e) {
      const t = (parseInt(this.input.value) || this.min) + e;
      this.setValue(t);
    }
    setValue(e) {
      const t = this.validateValue(e);
      this.input.value !== t.toString() &&
        ((this.input.value = t),
        this.input.dispatchEvent(new Event("change", { bubbles: !0 })),
        this.dispatchEvent(
          new CustomEvent("quantity:changed", {
            bubbles: !0,
            detail: {
              value: t,
              previousValue:
                parseInt(this.input.dataset.previousValue) || this.min,
              input: this,
            },
          })
        ),
        (this.input.dataset.previousValue = t.toString()),
        this.announceQuantityChange(t)),
        this.updateButtonStates();
    }
    validateValue(e) {
      const t = parseInt(e);
      if (isNaN(t)) return this.min;
      if (t < this.min) return this.min;
      if (this.max && t > this.max) return this.max;
      const s = (t - this.min) % this.step;
      return 0 !== s ? t - s : t;
    }
    validateAndUpdate() {
      const e = parseInt(this.input.value),
        t = this.validateValue(e);
      e !== t && this.setValue(t);
    }
    updateButtonStates() {
      const e = parseInt(this.input.value) || this.min;
      if (this.decreaseButton) {
        const t = e > this.min;
        (this.decreaseButton.disabled = !t),
          this.decreaseButton.setAttribute("aria-disabled", !t);
      }
      if (this.increaseButton) {
        const t = !this.max || e < this.max;
        (this.increaseButton.disabled = !t),
          this.increaseButton.setAttribute("aria-disabled", !t);
      }
    }
    announceQuantityChange(e) {
      const t = this.querySelector("[aria-live]");
      t && (t.textContent = `Quantity changed to ${e}`);
    }
    cleanup() {}
    get value() {
      return parseInt(this.input?.value) || this.min;
    }
    set value(e) {
      this.setValue(e);
    }
    get minimum() {
      return this.min;
    }
    set minimum(e) {
      (this.min = parseInt(e)),
        this.input && this.input.setAttribute("min", this.min.toString()),
        this.validateAndUpdate();
    }
    get maximum() {
      return this.max;
    }
    set maximum(e) {
      (this.max = parseInt(e)),
        this.input &&
          (this.max
            ? this.input.setAttribute("max", this.max.toString())
            : this.input.removeAttribute("max")),
        this.validateAndUpdate();
    }
    increase() {
      this.changeQuantity(this.step);
    }
    decrease() {
      this.changeQuantity(-this.step);
    }
    reset() {
      this.setValue(this.min);
    }
  }
  const M = "/cart" === window.location.pathname;
  customElements.get("quantity-input") ||
    M ||
    customElements.define("quantity-input", x);
  class T extends HTMLElement {
    constructor() {
      super(),
        (this.detailsContainer = null),
        (this.summaryToggle = null),
        (this.closeButton = null),
        (this.focusTrap = null),
        (this.isOpen = !1);
    }
    connectedCallback() {
      this.setupDOM(), this.setupEventListeners(), this.setupAccessibility();
    }
    disconnectedCallback() {
      this.cleanup();
    }
    setupDOM() {
      (this.detailsContainer =
        this.querySelector("details") || this.closest("details")),
        (this.summaryToggle = this.querySelector("summary")),
        (this.closeButton = this.querySelector(".modal-close-button")),
        this.detailsContainer ||
          ((this.detailsContainer = document.createElement("details")),
          this.parentNode.insertBefore(this.detailsContainer, this),
          this.detailsContainer.appendChild(this));
    }
    setupEventListeners() {
      this.summaryToggle &&
        this.summaryToggle.addEventListener(
          "click",
          this.handleSummaryClick.bind(this)
        ),
        this.closeButton &&
          this.closeButton.addEventListener("click", this.close.bind(this)),
        this.detailsContainer &&
          this.detailsContainer.addEventListener(
            "toggle",
            this.handleToggle.bind(this)
          ),
        this.addEventListener("keydown", this.handleKeydown.bind(this)),
        this.addEventListener("click", this.handleBackdropClick.bind(this)),
        document.addEventListener(
          "modal:opened",
          this.handleModalOpened.bind(this)
        ),
        document.addEventListener(
          "modal:closed",
          this.handleModalClosed.bind(this)
        );
    }
    setupAccessibility() {
      if (
        (this.setAttribute("role", "dialog"),
        this.setAttribute("aria-modal", "true"),
        this.summaryToggle &&
          (this.summaryToggle.setAttribute("aria-expanded", "false"),
          this.summaryToggle.setAttribute("aria-haspopup", "dialog")),
        !this.getAttribute("aria-labelledby"))
      ) {
        const e = this.querySelector(".modal-title, h1, h2, h3");
        e &&
          (e.id ||
            (e.id = `modal-title-${Math.random().toString(36).substr(2, 9)}`),
          this.setAttribute("aria-labelledby", e.id));
      }
    }
    handleSummaryClick(e) {
      e.preventDefault(),
        this.detailsContainer.hasAttribute("open") ? this.close() : this.open();
    }
    handleToggle(e) {
      this.detailsContainer.hasAttribute("open")
        ? this.handleOpen()
        : this.handleClose();
    }
    handleKeydown(e) {
      if (this.isOpen && "Escape" === e.key) e.preventDefault(), this.close();
    }
    handleBackdropClick(e) {
      e.target === this && this.isOpen && this.close();
    }
    handleModalOpened(e) {
      e.detail.modal === this && (document.body.style.overflow = "hidden");
    }
    handleModalClosed(e) {
      e.detail.modal === this && (document.body.style.overflow = "");
    }
    open() {
      this.isOpen ||
        (this.detailsContainer.setAttribute("open", ""), this.handleOpen());
    }
    handleOpen() {
      (this.isOpen = !0),
        this.classList.add("modal--open"),
        this.summaryToggle &&
          this.summaryToggle.setAttribute("aria-expanded", "true"),
        this.setupFocusTrap(),
        document.body.classList.add("modal-open"),
        document.dispatchEvent(
          new CustomEvent("modal:opened", { detail: { modal: this } })
        ),
        this.dispatchEvent(
          new CustomEvent("details-modal:opened", {
            bubbles: !0,
            detail: { modal: this },
          })
        );
    }
    close() {
      this.isOpen &&
        (this.detailsContainer.removeAttribute("open"), this.handleClose());
    }
    handleClose() {
      (this.isOpen = !1),
        this.classList.remove("modal--open"),
        this.summaryToggle &&
          this.summaryToggle.setAttribute("aria-expanded", "false"),
        this.removeFocusTrap(),
        document.body.classList.remove("modal-open"),
        this.summaryToggle && this.summaryToggle.focus(),
        document.dispatchEvent(
          new CustomEvent("modal:closed", { detail: { modal: this } })
        ),
        this.dispatchEvent(
          new CustomEvent("details-modal:closed", {
            bubbles: !0,
            detail: { modal: this },
          })
        );
    }
    setupFocusTrap() {
      if (window.DOMUtils) {
        const e =
          this.querySelector(
            'input, button, select, textarea, a[href], [tabindex]:not([tabindex="-1"])'
          ) || this.closeButton;
        this.focusTrap = window.DOMUtils.trapFocus(this, e);
      } else {
        const e = this.querySelector(
          'input, button, select, textarea, a[href], [tabindex]:not([tabindex="-1"])'
        );
        e && e.focus();
      }
    }
    removeFocusTrap() {
      this.focusTrap &&
        "function" == typeof this.focusTrap &&
        (this.focusTrap(), (this.focusTrap = null));
    }
    cleanup() {
      this.removeFocusTrap(),
        this.isOpen &&
          (document.body.classList.remove("modal-open"),
          (document.body.style.overflow = "")),
        document.removeEventListener(
          "modal:opened",
          this.handleModalOpened.bind(this)
        ),
        document.removeEventListener(
          "modal:closed",
          this.handleModalClosed.bind(this)
        );
    }
    toggle() {
      this.isOpen ? this.close() : this.open();
    }
    get opened() {
      return this.isOpen;
    }
    show() {
      this.open();
    }
    hide() {
      this.close();
    }
  }
  customElements.get("details-modal") ||
    customElements.define("details-modal", T),
    (window.DetailsModal = T);
  class _ {
    constructor() {
      (this.header = null),
        (this.mobileMenu = null),
        (this.mobileMenuToggle = null),
        (this.mobileMenuClose = null),
        (this.isMobileMenuOpen = !1),
        this.init();
    }
    init() {
      "loading" === document.readyState
        ? document.addEventListener("DOMContentLoaded", () => this.setup())
        : this.setup();
    }
    setup() {
      this.findElements(),
        this.setupScrollEffects(),
        this.setupMobileMenu(),
        this.initializeHeaderState();
    }
    findElements() {
      (this.header =
        document.querySelector(".header") ||
        document.querySelector("header") ||
        document.querySelector("#header")),
        (this.mobileMenu = document.getElementById("mobile-menu")),
        (this.mobileMenuToggle = document.querySelector(
          "[data-mobile-menu-toggle]"
        )),
        (this.mobileMenuClose = document.querySelector(".mobile-menu__close")),
        this.header ||
          console.error("❌ HEADER NOT FOUND! Available elements:", {
            ".header": document.querySelector(".header"),
            header: document.querySelector("header"),
            "#header": document.querySelector("#header"),
          });
    }
    setupScrollEffects() {
      if (!this.header) return;
      let e = 0;
      const t = (e) => {
        const t = Math.min(e / 300, 1);
        this.header.style.setProperty("--scroll-progress", t),
          e > 0
            ? (this.header.classList.add("header--scrolled"),
              this.header.classList.remove("header--transparent"))
            : (this.header.classList.remove("header--scrolled"),
              this.header.classList.add("header--transparent"));
      };
      let s = !1;
      window.addEventListener(
        "scroll",
        () => {
          s ||
            (requestAnimationFrame(() => {
              const i =
                window.pageYOffset || document.documentElement.scrollTop;
              t(i), (e = i), (s = !1);
            }),
            (s = !0));
        },
        { passive: !0 }
      );
      const i = window.pageYOffset || document.documentElement.scrollTop;
      t(i);
    }
    setupMobileMenu() {
      if (!this.mobileMenu || !this.mobileMenuToggle || !this.mobileMenuClose)
        return;
      this.mobileMenu.classList.remove("mobile-menu--open"),
        this.mobileMenu.setAttribute("aria-hidden", "true"),
        document.body.classList.remove("overflow-hidden"),
        this.mobileMenuToggle.addEventListener("click", () => {
          this.toggleMobileMenu();
        }),
        this.mobileMenuClose.addEventListener("click", () => {
          this.closeMobileMenu();
        }),
        document.addEventListener("keydown", (e) => {
          "Escape" === e.key && this.isMobileMenuOpen && this.closeMobileMenu();
        }),
        this.mobileMenu.addEventListener("click", (e) => {
          e.target === this.mobileMenu && this.closeMobileMenu();
        });
      this.mobileMenu.querySelectorAll("a").forEach((e) => {
        e.addEventListener("click", () => {
          this.closeMobileMenu();
        });
      });
    }
    toggleMobileMenu() {
      this.isMobileMenuOpen ? this.closeMobileMenu() : this.openMobileMenu();
    }
    openMobileMenu() {
      this.mobileMenu &&
        this.mobileMenuToggle &&
        ((this.isMobileMenuOpen = !0),
        this.mobileMenuToggle.setAttribute("aria-expanded", "true"),
        this.mobileMenu.classList.add("mobile-menu--open"),
        this.mobileMenu.setAttribute("aria-hidden", "false"),
        document.body.classList.add("overflow-hidden"),
        this.mobileMenuClose && this.mobileMenuClose.focus());
    }
    closeMobileMenu() {
      this.mobileMenu &&
        this.mobileMenuToggle &&
        ((this.isMobileMenuOpen = !1),
        this.mobileMenuToggle.setAttribute("aria-expanded", "false"),
        this.mobileMenu.classList.remove("mobile-menu--open"),
        this.mobileMenu.setAttribute("aria-hidden", "true"),
        document.body.classList.remove("overflow-hidden"),
        this.mobileMenuToggle && this.mobileMenuToggle.focus());
    }
    initializeHeaderState() {
      if (!this.header) return;
      this.header.classList.add("header--transparent"),
        this.header.classList.remove("header--scrolled"),
        this.header.classList.remove("header--hidden"),
        this.header.style.setProperty("--scroll-progress", "0");
      0 === (window.pageYOffset || document.documentElement.scrollTop) &&
        (this.header.classList.add("header--transparent"),
        this.header.classList.remove("header--scrolled"));
    }
  }
  let I;
  "loading" === document.readyState
    ? document.addEventListener("DOMContentLoaded", () => {
        (I = new _()), (window.headerManager = I);
      })
    : ((I = new _()), (window.headerManager = I)),
    (window.HeaderManager = _);
  class q {
    constructor() {
      (this.searchModal = null),
        (this.searchToggle = null),
        (this.searchClose = null),
        (this.searchInput = null),
        (this.isSearchModalOpen = !1),
        (this.searchTimeout = null),
        this.init();
    }
    init() {
      "loading" === document.readyState
        ? document.addEventListener("DOMContentLoaded", () => this.setup())
        : this.setup();
    }
    setup() {
      this.findElements(), this.setupSearchModal();
    }
    findElements() {
      (this.searchModal = document.getElementById("search-modal")),
        (this.searchToggle = document.querySelector("[data-search-toggle]")),
        (this.searchClose = document.querySelector("[data-search-close]")),
        (this.searchInput = document.querySelector(".search-modal__input"));
    }
    setupSearchModal() {
      this.searchModal &&
        this.searchToggle &&
        this.searchClose &&
        this.searchInput &&
        (this.searchToggle.addEventListener("click", () => {
          this.openSearchModal();
        }),
        this.searchClose.addEventListener("click", () => {
          this.closeSearchModal();
        }),
        document.addEventListener("keydown", (e) => {
          "Escape" === e.key &&
            this.isSearchModalOpen &&
            this.closeSearchModal();
        }),
        this.searchModal.addEventListener("click", (e) => {
          const t = this.searchModal.querySelector(".search-modal__content");
          (t && t.contains(e.target)) || this.closeSearchModal();
        }),
        this.setupPredictiveSearch());
    }
    setupPredictiveSearch() {
      this.searchInput &&
        this.searchInput.addEventListener("input", () => {
          const e = this.searchInput.value.trim();
          if ((clearTimeout(this.searchTimeout), e.length < 2))
            return void this.clearSearchResults();
          this.showSearchLoading();
          window.THEME_CONFIG;
          this.searchTimeout = setTimeout(() => {
            this.performPredictiveSearch(e);
          }, 300);
        });
    }
    async performPredictiveSearch(e) {
      try {
        const t = await fetch(
          `/search/suggest.json?q=${encodeURIComponent(
            e
          )}&resources[type]=product&resources[limit]=6`
        );
        if (!t.ok) throw new Error("Search request failed");
        const s = await t.json();
        this.displaySearchResults(s, e);
      } catch (e) {
        console.error("Search error:", e), this.showNoResults();
      }
    }
    displaySearchResults(e, t) {
      const s = document.querySelector(".search-modal__content-results"),
        i = document.querySelector(".search-modal__loading"),
        n = document.querySelector(".search-modal__no-results");
      if (!s) return;
      i && i.classList.add("hidden");
      let o = [];
      if (e.resources && e.resources.results)
        if (Array.isArray(e.resources.results)) o = e.resources.results;
        else if ("object" == typeof e.resources.results) {
          const t = e.resources.results;
          Object.keys(t).forEach((e) => {
            Array.isArray(t[e]) && o.push(...t[e]);
          });
        }
      if (0 === o.length) return void this.showNoResults();
      let r = '<div class="space-y-4">';
      o.forEach((e) => {
        if (!e || !e.title) return;
        const s = e.handle ? `/products/${e.handle}` : e.url || "",
          i = this.highlightQuery(e.title, t),
          n = e.price
            ? `<span class="text-primary font-semibold">$${e.price}</span>`
            : "",
          o = e.image
            ? `<img src="${e.image}" alt="${e.title}" class="w-12 h-12 object-cover rounded-lg">`
            : "";
        r += `\n        <a href="${s}" class="search-result-item flex items-center gap-4 p-3 rounded-lg hover:bg-gray-800/60 transition-colors duration-200 group">\n          <div class="flex-shrink-0">\n            ${o}\n          </div>\n          <div class="flex-1 min-w-0">\n            <h3 class="text-white font-medium group-hover:text-primary transition-colors duration-200">${i}</h3>\n            ${
          n ? `<p class="text-sm text-gray-400 mt-1">${n}</p>` : ""
        }\n          </div>\n          <div class="flex-shrink-0 text-gray-400 group-hover:text-primary transition-colors duration-200">\n            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">\n              <path fill-rule="evenodd" d="M12.97 3.97a.75.75 0 011.06 0l7.5 7.5a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 11-1.06-1.06l6.22-6.22H3a.75.75 0 010-1.5h16.19l-6.22-6.22a.75.75 0 010-1.06z" clip-rule="evenodd"/>\n            </svg>\n          </div>\n        </a>\n      `;
      }),
        (r += "</div>"),
        (s.innerHTML = r),
        s.classList.remove("hidden"),
        n && n.classList.add("hidden");
    }
    showSearchLoading() {
      const e = document.querySelector(".search-modal__loading"),
        t = document.querySelector(".search-modal__content-results"),
        s = document.querySelector(".search-modal__no-results");
      e && e.classList.remove("hidden"),
        t && t.classList.add("hidden"),
        s && s.classList.add("hidden");
    }
    clearSearchResults() {
      const e = document.querySelector(".search-modal__content-results"),
        t = document.querySelector(".search-modal__loading"),
        s = document.querySelector(".search-modal__no-results");
      e && ((e.innerHTML = ""), e.classList.add("hidden")),
        t && t.classList.add("hidden"),
        s && s.classList.add("hidden");
    }
    showNoResults() {
      const e = document.querySelector(".search-modal__no-results"),
        t = document.querySelector(".search-modal__content-results"),
        s = document.querySelector(".search-modal__loading");
      s && s.classList.add("hidden"),
        t && t.classList.add("hidden"),
        e && e.classList.remove("hidden");
    }
    highlightQuery(e, t) {
      if (!t) return e;
      const s = new RegExp(`(${t})`, "gi");
      return e.replace(
        s,
        '<mark class="bg-primary/20 text-primary px-1 rounded">$1</mark>'
      );
    }
    openSearchModal() {
      this.searchModal &&
        this.searchInput &&
        ((this.isSearchModalOpen = !0),
        this.searchModal.classList.remove("hidden"),
        document.body.classList.add("overflow-hidden"),
        this.searchInput.focus(),
        this.clearSearchResults());
    }
    closeSearchModal() {
      this.searchModal &&
        this.searchInput &&
        ((this.isSearchModalOpen = !1),
        this.searchModal.classList.add("hidden"),
        document.body.classList.remove("overflow-hidden"),
        (this.searchInput.value = ""),
        this.clearSearchResults());
    }
    get isOpen() {
      return this.isSearchModalOpen;
    }
    toggle() {
      this.isSearchModalOpen ? this.closeSearchModal() : this.openSearchModal();
    }
  }
  const O = new q();
  (window.SearchManager = q), (window.searchManager = O);
  class D extends HTMLElement {
    constructor() {
      super(),
        (this.input = null),
        (this.results = null),
        (this.closeButton = null),
        (this.focusTrap = null),
        (this.isOpen = !1),
        (this.searchTimeout = null),
        (this.searchUtils = null);
    }
    connectedCallback() {
      (this.input = this.querySelector('input[type="search"]')),
        (this.results = this.querySelector(".search-results")),
        (this.closeButton = this.querySelector(".search-modal__close")),
        this.setupSearch(),
        this.setupAccessibility(),
        this.setupEventListeners(),
        window.SearchUtils && (this.searchUtils = new window.SearchUtils());
    }
    disconnectedCallback() {
      this.cleanup();
    }
    setupSearch() {
      this.input &&
        ((this.searchHandler = window.DOMUtils
          ? window.DOMUtils.debounce(this.performSearch.bind(this), 300)
          : this.debounceSearch(this.performSearch.bind(this), 300)),
        this.input.addEventListener("input", this.searchHandler),
        this.input.addEventListener("focus", this.handleInputFocus.bind(this)));
    }
    setupAccessibility() {
      this.input &&
        (this.input.setAttribute("aria-expanded", "false"),
        this.input.setAttribute("aria-haspopup", "listbox"),
        this.input.setAttribute("aria-autocomplete", "list"),
        this.input.setAttribute("role", "combobox")),
        this.results &&
          (this.results.setAttribute("role", "listbox"),
          this.results.setAttribute("aria-label", "Search results")),
        this.setAttribute("role", "dialog"),
        this.setAttribute("aria-modal", "true"),
        this.setAttribute("aria-labelledby", "search-modal-title");
    }
    setupEventListeners() {
      this.closeButton &&
        this.closeButton.addEventListener("click", this.close.bind(this)),
        this.addEventListener("keydown", this.handleKeydown.bind(this)),
        this.addEventListener("click", this.handleBackdropClick.bind(this)),
        this.results &&
          this.results.addEventListener(
            "click",
            this.handleResultClick.bind(this)
          ),
        (this.overlay = this.querySelector(".search-modal__overlay")),
        this.overlay &&
          this.overlay.addEventListener("click", this.close.bind(this));
    }
    handleInputFocus() {
      !this.isOpen &&
        this.input.value.trim().length > 0 &&
        this.performSearch();
    }
    handleKeydown(e) {
      switch (e.key) {
        case "Escape":
          this.close();
          break;
        case "ArrowDown":
          e.preventDefault(), this.navigateResults("down");
          break;
        case "ArrowUp":
          e.preventDefault(), this.navigateResults("up");
          break;
        case "Enter":
          e.preventDefault(), this.selectCurrentResult();
      }
    }
    handleBackdropClick(e) {
      const t = this.querySelector(".search-modal__content");
      (t && t.contains(e.target)) || this.close();
    }
    handleResultClick(e) {
      const t = e.target.closest("[data-search-result]");
      if (t) {
        const e = t.dataset.url || t.querySelector("a")?.href;
        e && (window.location.href = e);
      }
    }
    async performSearch() {
      const e = this.input?.value?.trim();
      if (!e || e.length < 2) this.hideResults();
      else {
        this.showLoadingState();
        try {
          let t;
          (t = this.searchUtils
            ? await this.searchUtils.performSearch(e, {
                limit: 8,
                resources: ["product", "collection", "page"],
              })
            : await this.basicSearch(e)),
            t && (this.displayResults(t), this.open());
        } catch (e) {
          console.error("Search error:", e), this.showErrorState();
        }
      }
    }
    async basicSearch(e) {
      try {
        const t = await fetch(
          `/search/suggest.json?q=${encodeURIComponent(
            e
          )}&resources[type]=product&resources[limit]=8`
        );
        if (!t.ok) throw new Error(`Search failed: ${t.status}`);
        const s = await t.json();
        return this.parseJsonResults(s, e);
      } catch (e) {
        throw (console.error("Search API error:", e), e);
      }
    }
    parseJsonResults(e, t) {
      const s = [];
      if (e.resources && e.resources.results)
        if (Array.isArray(e.resources.results)) s.push(...e.resources.results);
        else if ("object" == typeof e.resources.results) {
          const t = e.resources.results;
          Object.keys(t).forEach((e) => {
            Array.isArray(t[e]) && s.push(...t[e]);
          });
        }
      return (
        e.resources &&
          e.resources.products &&
          Array.isArray(e.resources.products) &&
          s.push(...e.resources.products),
        e.results && Array.isArray(e.results) && s.push(...e.results),
        s
          .map((e) => {
            if (!e || !e.title) return null;
            let t = "";
            if ("string" == typeof e.url) t = e.url;
            else if (e.handle) t = `/products/${e.handle}`;
            else {
              if (!e.id) return null;
              t = `/products/${e.id}`;
            }
            return {
              title: e.title || e.name || "",
              url: t,
              handle: e.handle || "",
              id: e.id || "",
              image: e.image || e.featured_image || "",
              price: e.price || e.price_min || "",
              compare_at_price: e.compare_at_price || e.price_max || "",
              available: !1 !== e.available,
              type: "product",
            };
          })
          .filter(Boolean)
      );
    }
    displayResults(e) {
      if (!this.results) return;
      let t = "";
      e.products &&
        e.products.length > 0 &&
        ((t += '<div class="search-results__section">'),
        (t += '<h3 class="search-results__heading">Products</h3>'),
        (t += '<ul class="search-results__list" role="listbox">'),
        e.products.forEach((s, i) => {
          t += `\n          <li class="search-results__item" role="option" data-search-result data-url="${
            s.url
          }" tabindex="-1">\n            <a href="${
            s.url
          }" class="search-results__link">\n              ${
            s.image
              ? `<img src="${s.image}" alt="${s.title}" class="search-results__image" loading="lazy">`
              : ""
          }\n              <div class="search-results__content">\n                <h4 class="search-results__title">${this.highlightQuery(
            s.title,
            e.query
          )}</h4>\n                ${
            s.price
              ? `<span class="search-results__price">${s.price}</span>`
              : ""
          }\n              </div>\n            </a>\n          </li>\n        `;
        }),
        (t += "</ul></div>")),
        e.collections &&
          e.collections.length > 0 &&
          ((t += '<div class="search-results__section">'),
          (t += '<h3 class="search-results__heading">Collections</h3>'),
          (t += '<ul class="search-results__list" role="listbox">'),
          e.collections.forEach((s) => {
            t += `\n          <li class="search-results__item" role="option" data-search-result data-url="${
              s.url
            }" tabindex="-1">\n            <a href="${
              s.url
            }" class="search-results__link">\n              ${
              s.image
                ? `<img src="${s.image}" alt="${s.title}" class="search-results__image" loading="lazy">`
                : ""
            }\n              <div class="search-results__content">\n                <h4 class="search-results__title">${this.highlightQuery(
              s.title,
              e.query
            )}</h4>\n              </div>\n            </a>\n          </li>\n        `;
          }),
          (t += "</ul></div>")),
        "" === t &&
          (t = '<div class="search-results__empty">No results found</div>'),
        (this.results.innerHTML = t),
        this.updateAccessibilityAttributes();
    }
    highlightQuery(e, t) {
      if (!e || !t) return e;
      if (window.SearchUtils && window.SearchUtils.highlightSearchTerms)
        return window.SearchUtils.highlightSearchTerms(e, t);
      const s = new RegExp(
        `(${t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")})`,
        "gi"
      );
      return e.replace(s, "<mark>$1</mark>");
    }
    showLoadingState() {
      this.results &&
        (this.results.innerHTML =
          '<div class="search-results__loading">Searching...</div>');
    }
    showErrorState() {
      this.results &&
        (this.results.innerHTML =
          '<div class="search-results__error">Search failed. Please try again.</div>');
    }
    hideResults() {
      this.results && (this.results.innerHTML = ""), this.close();
    }
    updateAccessibilityAttributes() {
      const e = this.results?.querySelectorAll(".search-results__item");
      e &&
        e.forEach((e, t) => {
          e.setAttribute("id", `search-result-${t}`);
        }),
        this.input &&
          this.input.setAttribute(
            "aria-expanded",
            this.isOpen ? "true" : "false"
          );
    }
    navigateResults(e) {
      const t = this.results?.querySelectorAll(".search-results__item");
      if (!t || 0 === t.length) return;
      const s = Array.from(t).findIndex((e) =>
        e.classList.contains("search-results__item--focused")
      );
      let i;
      (i =
        "down" === e
          ? s < t.length - 1
            ? s + 1
            : 0
          : s > 0
          ? s - 1
          : t.length - 1),
        t.forEach((e) => e.classList.remove("search-results__item--focused")),
        t[i].classList.add("search-results__item--focused"),
        t[i].focus();
    }
    selectCurrentResult() {
      const e = this.results?.querySelector(".search-results__item--focused");
      if (e) {
        const t = e.querySelector("a");
        t && t.click();
      }
    }
    open() {
      this.isOpen ||
        ((this.isOpen = !0),
        this.classList.add("search-modal--open"),
        (document.body.style.overflow = "hidden"),
        this.setupFocusTrap(),
        this.dispatchEvent(
          new CustomEvent("search-modal:opened", {
            bubbles: !0,
            detail: { modal: this },
          })
        ));
    }
    close() {
      if (!this.isOpen) return;
      (this.isOpen = !1),
        this.classList.remove("search-modal--open"),
        (document.body.style.overflow = ""),
        this.removeFocusTrap(),
        this.results && (this.results.innerHTML = "");
      const e = document.querySelector("[data-search-trigger]");
      e && e.focus(),
        this.dispatchEvent(
          new CustomEvent("search-modal:closed", {
            bubbles: !0,
            detail: { modal: this },
          })
        );
    }
    setupFocusTrap() {
      window.DOMUtils
        ? (this.focusTrap = window.DOMUtils.trapFocus(this, this.input))
        : this.input && this.input.focus();
    }
    removeFocusTrap() {
      this.focusTrap &&
        "function" == typeof this.focusTrap &&
        (this.focusTrap(), (this.focusTrap = null));
    }
    debounceSearch(e, t = null) {
      const s = t || window.THEME_CONFIG?.ON_CHANGE_DEBOUNCE_TIMER || 300;
      return (...t) => {
        clearTimeout(this.searchTimeout),
          (this.searchTimeout = setTimeout(() => e.apply(this, t), s));
      };
    }
    cleanup() {
      this.searchTimeout && clearTimeout(this.searchTimeout),
        this.removeFocusTrap(),
        this.isOpen && (document.body.style.overflow = "");
    }
    toggle() {
      this.isOpen ? this.close() : this.open();
    }
    get opened() {
      return this.isOpen;
    }
  }
  customElements.get("search-modal") ||
    customElements.define("search-modal", D),
    (window.SearchModal = D);
  class N {
    constructor() {
      this.init();
    }
    init() {
      this.bindEvents();
    }
    bindEvents() {
      document.addEventListener("click", (e) => {
        if (
          e.target.closest('[data-mobile-action="open-menu"]') &&
          !(window.innerWidth >= 768)
        )
          if (
            (e.preventDefault(),
            window.mobileMenu && "function" == typeof window.mobileMenu.open)
          )
            window.mobileMenu.open();
          else {
            const e = document.querySelector("[data-mobile-menu-toggle]");
            e && e.click();
          }
      });
    }
  }
  document.addEventListener("DOMContentLoaded", () => {
    new N();
  });
  const B = new (class {
    constructor() {
      (this.isEditor = !1),
        (this.sections = new Map()),
        (this.blocks = new Map()),
        this.init();
    }
    init() {
      this.detectEditor(),
        this.setupEventListeners(),
        this.initializeSections();
    }
    detectEditor() {
      (this.isEditor =
        "design" === window.Shopify?.designMode ||
        document.body.classList.contains("shopify-design-mode") ||
        window.location.search.includes("preview_theme_id")),
        this.isEditor && document.documentElement.classList.add("theme-editor");
    }
    setupEventListeners() {
      this.isEditor &&
        (document.addEventListener("shopify:section:load", (e) => {
          this.handleSectionLoad(e);
        }),
        document.addEventListener("shopify:section:unload", (e) => {
          this.handleSectionUnload(e);
        }),
        document.addEventListener("shopify:section:select", (e) => {
          this.handleSectionSelect(e);
        }),
        document.addEventListener("shopify:section:deselect", (e) => {
          this.handleSectionDeselect(e);
        }),
        document.addEventListener("shopify:block:select", (e) => {
          this.handleBlockSelect(e);
        }),
        document.addEventListener("shopify:block:deselect", (e) => {
          this.handleBlockDeselect(e);
        }),
        document.addEventListener("shopify:theme:load", (e) => {
          this.handleThemeLoad(e);
        }),
        window.Shopify?.on &&
          window.Shopify.on("shopify:section:reorder", (e) => {
            this.handleSectionReorder(e);
          }));
    }
    initializeSections() {
      if (!this.isEditor) return;
      document.querySelectorAll("[data-section-id]").forEach((e) => {
        this.registerSection(e);
      });
    }
    registerSection(e) {
      const t = e.dataset.sectionId;
      if (!t) return;
      const s = {
        element: e,
        id: t,
        type: e.dataset.sectionType,
        blocks: new Map(),
        initialized: !1,
      };
      this.sections.set(t, s), this.initializeSectionBlocks(s);
    }
    initializeSectionBlocks(e) {
      e.element.querySelectorAll("[data-block-id]").forEach((t) => {
        const s = t.dataset.blockId;
        if (!s) return;
        const i = {
          element: t,
          id: s,
          type: t.dataset.blockType,
          sectionId: e.id,
        };
        e.blocks.set(s, i), this.blocks.set(s, i);
      });
    }
    handleSectionLoad(e) {
      const t = e.detail.sectionId,
        s = e.target;
      this.registerSection(s),
        this.initializeSectionFunctionality(t),
        s.dispatchEvent(
          new CustomEvent("section:loaded", {
            detail: { sectionId: t, section: this.sections.get(t) },
          })
        );
    }
    handleSectionUnload(e) {
      const t = e.detail.sectionId,
        s = this.sections.get(t);
      s &&
        (s.blocks.forEach((e, t) => {
          this.blocks.delete(t);
        }),
        this.sections.delete(t));
    }
    handleSectionSelect(e) {
      const t = e.detail.sectionId,
        s = this.sections.get(t);
      s &&
        (s.element.classList.add("section-selected"),
        s.element.dispatchEvent(
          new CustomEvent("section:selected", {
            detail: { sectionId: t, section: s },
          })
        ));
    }
    handleSectionDeselect(e) {
      const t = e.detail.sectionId,
        s = this.sections.get(t);
      s &&
        (s.element.classList.remove("section-selected"),
        s.element.dispatchEvent(
          new CustomEvent("section:deselected", {
            detail: { sectionId: t, section: s },
          })
        ));
    }
    handleBlockSelect(e) {
      const t = e.detail.blockId,
        s = this.blocks.get(t);
      s &&
        (s.element.classList.add("block-selected"),
        s.element.dispatchEvent(
          new CustomEvent("block:selected", {
            detail: { blockId: t, block: s },
          })
        ));
    }
    handleBlockDeselect(e) {
      const t = e.detail.blockId,
        s = this.blocks.get(t);
      s &&
        (s.element.classList.remove("block-selected"),
        s.element.dispatchEvent(
          new CustomEvent("block:deselected", {
            detail: { blockId: t, block: s },
          })
        ));
    }
    handleThemeLoad(e) {
      this.initializeSections(),
        document.dispatchEvent(
          new CustomEvent("theme:editor:loaded", {
            detail: { sections: this.sections, blocks: this.blocks },
          })
        );
    }
    handleSectionReorder(e) {
      document.dispatchEvent(
        new CustomEvent("sections:reordered", { detail: e.detail })
      );
    }
    initializeSectionFunctionality(e) {
      const t = this.sections.get(e);
      if (t && !t.initialized) {
        switch (t.type) {
          case "hero":
            this.initializeHeroSection(t);
            break;
          case "featured-products":
            this.initializeFeaturedProductsSection(t);
            break;
          case "main-product":
            this.initializeProductSection(t);
            break;
          case "customer-reviews":
            this.initializeReviewsSection(t);
            break;
          case "faq":
            this.initializeFaqSection(t);
            break;
          default:
            this.initializeGenericSection(t);
        }
        t.initialized = !0;
      }
    }
    initializeHeroSection(e) {
      const t = e.element.querySelector(".hero");
      if (t) {
        t.classList.add("editor-hero");
        t.querySelectorAll("[data-background-image]").forEach((e) => {
          e.classList.add("editor-editable");
        });
      }
    }
    initializeFeaturedProductsSection(e) {
      const t = e.element.querySelector(".product-grid");
      t && t.classList.add("editor-product-grid");
    }
    initializeProductSection(e) {
      const t = e.element.querySelector("product-form");
      t && t.classList.add("editor-product-form");
    }
    initializeReviewsSection(e) {
      const t = e.element.querySelector(".reviews-container");
      t && t.classList.add("editor-reviews");
    }
    initializeFaqSection(e) {
      e.element.querySelectorAll(".faq-item").forEach((e) => {
        e.classList.add("editor-faq-item");
      });
    }
    initializeGenericSection(e) {
      e.element.classList.add("editor-section");
    }
    getSection(e) {
      return this.sections.get(e);
    }
    getBlock(e) {
      return this.blocks.get(e);
    }
    getAllSections() {
      return Array.from(this.sections.values());
    }
    getAllBlocks() {
      return Array.from(this.blocks.values());
    }
    isInEditor() {
      return this.isEditor;
    }
    refreshSection(e) {
      const t = this.sections.get(e);
      t &&
        t.element.dispatchEvent(
          new CustomEvent("section:refresh", {
            detail: { sectionId: e, section: t },
          })
        );
    }
    updateSectionSettings(e, t) {
      const s = this.sections.get(e);
      s &&
        (Object.entries(t).forEach(([e, t]) => {
          s.element.style.setProperty(`--${e}`, t);
        }),
        s.element.dispatchEvent(
          new CustomEvent("section:settings:updated", {
            detail: { sectionId: e, section: s, settings: t },
          })
        ));
    }
    cleanup() {
      this.sections.clear(), this.blocks.clear();
    }
  })();
  if (((window.ThemeEditor = B), B.isInEditor())) {
    const e = document.createElement("style");
    (e.textContent =
      "\n    .theme-editor .section-selected {\n      outline: 2px solid #ffd800;\n      outline-offset: 2px;\n    }\n    \n    .theme-editor .block-selected {\n      outline: 2px solid #4791f0;\n      outline-offset: 1px;\n    }\n    \n    .theme-editor .editor-editable {\n      cursor: pointer;\n    }\n    \n    .theme-editor .editor-editable:hover {\n      opacity: 0.8;\n    }\n    \n    .theme-editor .editor-section {\n      position: relative;\n    }\n    \n    .theme-editor .editor-section::before {\n      content: attr(data-section-type);\n      position: absolute;\n      top: 0;\n      left: 0;\n      background: rgba(0, 0, 0, 0.7);\n      color: white;\n      padding: 0.25rem 0.5rem;\n      font-size: 0.75rem;\n      z-index: 1000;\n      border-radius: 0 0 4px 0;\n    }\n  "),
      document.head.appendChild(e);
  }
  function R(e, t) {
    customElements.get(e)
      ? console.warn(
          `Custom element '${e}' is already defined, skipping registration.`
        )
      : customElements.define(e, t);
  }
  class F extends HTMLElement {
    constructor() {
      super(), (this.initialized = !1);
    }
    connectedCallback() {
      this.initialized || (this.init(), (this.initialized = !0));
    }
    disconnectedCallback() {
      this.cleanup();
    }
    init() {}
    cleanup() {}
  }
  class H extends F {
    constructor() {
      super(),
        (this.modal = null),
        (this.closeButton = null),
        (this.focusableElements = []),
        (this.firstFocusableElement = null),
        (this.lastFocusableElement = null);
    }
    init() {
      (this.modal = this.querySelector(".modal__content")),
        (this.closeButton = this.querySelector(".modal__close-button")),
        this.bindEvents(),
        this.setupFocusTrap();
    }
    bindEvents() {
      this.closeButton?.addEventListener("click", () => this.hide()),
        this.addEventListener("keydown", (e) => {
          "Escape" === e.key && this.hide();
        }),
        this.addEventListener("click", (e) => {
          e.target === this && this.hide();
        });
    }
    setupFocusTrap() {
      (this.focusableElements = Array.from(
        this.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        )
      )),
        this.focusableElements.length > 0 &&
          ((this.firstFocusableElement = this.focusableElements[0]),
          (this.lastFocusableElement =
            this.focusableElements[this.focusableElements.length - 1]));
    }
    show() {
      this.setAttribute("open", ""),
        document.body.classList.add("modal-open"),
        this.firstFocusableElement?.focus(),
        this.addEventListener("keydown", this.handleTabKey.bind(this));
    }
    hide() {
      this.removeAttribute("open"),
        document.body.classList.remove("modal-open"),
        this.removeEventListener("keydown", this.handleTabKey.bind(this));
    }
    handleTabKey(e) {
      "Tab" === e.key &&
        (e.shiftKey
          ? document.activeElement === this.firstFocusableElement &&
            (e.preventDefault(), this.lastFocusableElement?.focus())
          : document.activeElement === this.lastFocusableElement &&
            (e.preventDefault(), this.firstFocusableElement?.focus()));
    }
    cleanup() {
      this.removeEventListener("keydown", this.handleTabKey.bind(this));
    }
  }
  class $ extends F {
    constructor() {
      super(),
        (this.form = null),
        (this.submitButton = null),
        (this.variantSelects = null),
        (this.quantityInput = null),
        (this.productId = null);
    }
    init() {
      (this.form = this.querySelector("form")),
        (this.submitButton = this.querySelector('[type="submit"]')),
        (this.variantSelects = this.querySelectorAll(".product-form__input")),
        (this.quantityInput = this.querySelector(".quantity__input")),
        (this.productId = this.dataset.productId),
        this.bindEvents();
    }
    bindEvents() {
      this.form?.addEventListener("submit", (e) => this.handleSubmit(e)),
        this.variantSelects.forEach((e) => {
          e.addEventListener("change", () => this.handleVariantChange());
        }),
        this.quantityInput?.addEventListener("change", () =>
          this.handleQuantityChange()
        );
    }
    async handleSubmit(e) {
      if ((e.preventDefault(), this.validateForm())) {
        this.setLoadingState(!0);
        try {
          const e = new FormData(this.form),
            t = await fetch("/cart/add.js", {
              method: "POST",
              headers: {
                "Accept": "application/json",
                "X-Requested-With": "XMLHttpRequest"
              },
              body: e
            });
          if (!t.ok) throw new Error("Add to cart failed");
          const s = await t.json();
          this.handleSuccess(s);
        } catch (e) {
          this.handleError(e);
        } finally {
          this.setLoadingState(!1);
        }
      }
    }
    validateForm() {
      const e = this.form.querySelectorAll("[required]");
      let t = !0;
      return (
        e.forEach((e) => {
          e.value.trim()
            ? e.classList.remove("error")
            : ((t = !1), e.classList.add("error"));
        }),
        t
      );
    }
    setLoadingState(e) {
      this.submitButton &&
        ((this.submitButton.disabled = e),
        (this.submitButton.textContent = e ? "Adding..." : "Add to Cart"));
    }
    handleSuccess(e) {
      document.dispatchEvent(
        new CustomEvent("cart:updated", { detail: { cart: e } })
      );
      const t = document.querySelector("cart-notification");
      t && t.show("Item added to cart successfully");
    }
    handleError(e) {
      console.error("Add to cart error:", e);
      const t = document.querySelector("cart-notification");
      t && t.show("Failed to add item to cart", "error");
    }
    handleVariantChange() {
      const e = Array.from(this.variantSelects).map((e) => e.value);
      this.dispatchEvent(
        new CustomEvent("variant:change", { detail: { selectedOptions: e } })
      );
    }
    handleQuantityChange() {
      const e = this.quantityInput?.value;
      e &&
        this.dispatchEvent(
          new CustomEvent("quantity:change", {
            detail: { quantity: parseInt(e) },
          })
        );
    }
  }
  R("modal-dialog", H),
    void 0 !== D
      ? R("search-modal", D)
      : console.warn("SearchModal not available - skipping registration"),
    R("cart-notification", C),
    R("product-form", $),
    (window.BloxManiaComponents = {
      ModalDialog: H,
      SearchModal: void 0 !== D ? D : null,
      CartNotification: C,
      ProductForm: $,
    });
})();
